import _ from 'lodash';
import React, { Component } from 'react';
import Modal from 'react-modal';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import ReactPlayer from 'react-player';
import 'react-confirm-alert/src/react-confirm-alert.css';
import Soap from './Soap';
import OpenTok from './OpenTok';
import Message from './Message';
import Screenshot from './Screenshot';
// import TimerOption from "./TimerOption";
import VideoOption from './VideoOptions';
import PatientMessage from './MessagePatient';
// import RecordingOption from "./RecordingOption";
import MessageLevelTwo from './MessageLevelTwo';
// import EncounterOption from "./EncounterOption";
import VideoCallLoader from './VideoCallLoader';
import PhysicianMessage from './MessagePhysician';
import PatientInformation from './PatientInformation';
import ParticipantContent from './ParticipantContent';
import PhysicianInformation from './PhysicianInformation';
import ScreenShotEditModal from './ScreenShotEditModal';
import { showNotification } from '../../../action/NotificationAction';
import { getHandout } from '../../../action/educator/AdminModuleAction';
// import Footer from "../../common/Footer";
// import GetImage from "../../common/GetImage";
import SocketDownScreen from '../../common/SocketDownScreen';
import LanguageContext, { LanguageProvider } from '../../../../utils/common/LanguageContext';
import {
    clearUnreadCount,
    onMuteVideo,
    onPatientEndCall,
    onSendMessage,
    startChatSocketConnect,
    stopChatSocketConnect,
} from '../../../action/SocketActions';
import {
    getNewVideoFlowConfig,
    getVonageSessionDetails,
    endVideoCall,
    getPatientVisitEncounter,
    getVideoChat,
    saveSnapShot,
    startVideoRecord,
    stopVideoRecord,
    updateSoap,
    startBroadCast,
    endStudentBroadCastSession,
    classRoomStudentRemove,
    educatorMuteMessage,
    joinInPersonSession,
    anonymousUserDetails,
    getVisitStatus,
} from '../../../action/VideoCallAction';
import { clearTimOutInterval, resetTimeOutInterval } from '../../../../utils/AthuService';
import {
    // Visit,
    // waitingRoom,
    liveStreamBroadCast,
    Tutor,
    Doctor,
    Patient,
    Student,
    LevelTwoAdmin,
    waitingRooms,
    Anonymous,
} from '../../../../utils/common/NamingTerms';
import { PATH } from '../../../../utils/Constants';
import { RESPONSE_CONSTANT } from '../../../../utils/ResponseConstant';
import { IM_PATIENT, IM_PHYSICIAN, isWhiteLabled } from '../../../../utils/URL';
import { myLog } from '../../../../utils/Utility';
//Images
// import FetchConnectionSpeed from '../../common/FetchConnectionSpeed';
import { getKidInfo } from '../../../action/educator/MyPatientInfoAction';
import store from '../../../../sessionStorage';
import { LEVEL_TWO_ADMIN_ROUTES_SECONDARY_PATH } from '../../../../utils/routes/path';
import { endVideoChatClear } from '../../../action/VideoCallAction';
import { Spinner } from 'react-activity';
import AppConfig from '../../../../utils/common/DomainConfiguration';
import { green } from '@mui/material/colors';
import {
    clearWhiteboardDataForSession,
    pruneWhiteboardSessionsExcept,
    setActiveWhiteboardSession,
} from '../../../../utils/WhiteboardSessionStorage';

// ⚠️ TEST MODE: Set to true to force using ONLY vonage API (for testing)
const VONAGE_API_TEST_MODE = false; // ❌ Normal mode (set to true for testing)

/**
 * @constant {Object} SESSION_JOIN_SOURCE - Enum for tracking which credential source established the session
 * @property {string} PRIMARY_CREDENTIALS - Session joined using primary credentials (apikey, opentokSession, opentokToken)
 * @property {string} SOCKET_SESSION_DETAILS - Session joined using vonage_session_details from socket when primary unavailable
 * @property {string} SESSION_API_FALLBACK - Session joined using vonage-session/{visitId} API as final fallback
 */
const SESSION_JOIN_SOURCE = {
    PRIMARY_CREDENTIALS: 'PRIMARY_CREDENTIALS',
    SOCKET_SESSION_DETAILS: 'SOCKET_SESSION_DETAILS',
    SESSION_API_FALLBACK: 'SESSION_API_FALLBACK',
    NONE: 'NONE', // Used when credentials are not yet available
};
const NETWORK_RECONNECT_STOP_BEFORE_INIT_KEY = 'networkReconnectStopBeforeInit';
const NETWORK_RECONNECT_STOP_TIMEOUT = 1000;
// How long the "you have left" popup stays up before the tab is closed.
const LEFT_SESSION_CLOSE_DELAY = 2000;

const setMeetingSummaryPendingForSession = (visitId) => {
    const normalizedVisitId = String(visitId || '');
    const existingVisitId = sessionStorage.getItem('LAST_VISITED_SESSION_ID') || '';
    const existingPendingAtRaw = sessionStorage.getItem('MEETING_SUMMARY_PENDING_AT');
    const existingPendingAt = Number(existingPendingAtRaw);
    const shouldResetPendingAt =
        existingVisitId !== normalizedVisitId || !Number.isFinite(existingPendingAt);

    sessionStorage.setItem('LAST_VISITED_SESSION_ID', normalizedVisitId);
    sessionStorage.setItem('MEETING_SUMMARY_PENDING', 'true');
    if (shouldResetPendingAt) {
        sessionStorage.setItem('MEETING_SUMMARY_PENDING_AT', String(Date.now()));
    }
};

// Higher-Order Component to inject translation function
const withLanguage = (WrappedComponent) => {
    return class extends Component {
        render() {
            return (
                <LanguageContext.Consumer>
                    {({ t }) => <WrappedComponent {...this.props} t={t} />}
                </LanguageContext.Consumer>
            );
        }
    };
};

let width = window.innerWidth;
let isMobileView = false;
if (width <= 768) {
    isMobileView = true;
}

/**
 * @package VirtuOwl
 * @type {React.ComponentClass}
 */
class ActiveVisit extends Component {
    static propTypes = {
        getKidInfo: PropTypes.func,
    };
    constructor(props) {
        super(props);
        this.state = {
            isClassRoom: false,
            isBroadCast: false,
            showMessagePop: false,
            showParticipants: false,
            isShowScreenShot: false,
            showSoap: false,
            endVideoCallModal: false,
            showTimer: true,
            videoCallVisitId: this.props.match.params.visitId,
            windowHeight: 768,
            windowWidth: 1024,
            minWidth: false,
            messageClicked: false,
            isStreamsAvailable: false,
            isShowVideoConsultation: false,
            isAllowAudioVideoChatBtn: false,
            isAllowEndVisitBtn: false,
            isVisitCreditAllow: false,
            isVisitEncounterInfoScreen: false,
            isVisitInfoWithUserInfoScreen: false,
            isShowChatBtn: false,
            screenShare: false,
            fullScreen: false,
            showBoard: false,
            whiteBoard: false,
            hideWhiteBoard: false,
            isBroadCastEnable: false,
            activeTab:
                sessionStorage.getItem('VISIT_TYPE') === 'class_room' || 
                sessionStorage.getItem('VISIT_TYPE') === 'class_room_session' ||
                sessionStorage.getItem('VISIT_TYPE') === 'broadcast' || 
                sessionStorage.getItem('VISIT_TYPE') === 'conference_call' 
                    ? 'participants'
                    : 'sessionNotes',
            sessionUsers: [],
            externalUsersDetails: [],
            streams: [],
            showColor: '',
            cancelShare: false,
            endVideoCallBufferAlert: false,
            endVideoCallFinalBufferAlert: false,
            isInitialCallLoader: true,
            muteAudioSingleStudent: false,
            muteVideoSingleStudent: false,
            removeStudentAlert: false,
            currentChatPage: 0,
            chatPerPage: 10,
            chatLastPage: '',
            isVideoButtonDisabled: false,
            isAudioButtonDisabled: false,
            mutePublisherVideoClicked: false,
            mutePublisherVoiceClicked: false,
            showWhiteboard: false,
            urlParams: {},
            hasLeftSession: false,
            visitNotJoinable: false,
            // Held shut until the visit status check answers, so a returning
            // third party cannot walk back in while the call is in flight.
            awaitingVisitStatus:
                new URLSearchParams(window.location.search).get('role') === Anonymous,
            showEarlyJoinModal: false,
            showAnonymousModal: false,
            firstName: '',
            lastName: '',
            isGroupSession: false,
            isOnetoOne: false,
            isConferenceCall: false,
            sessionJoinSource: SESSION_JOIN_SOURCE.NONE,
        };
        // Track when the video session component is initialized
        this.sessionStartTime = Date.now();
        this.sessionFallbackRequested = false;
        this.sessionFallbackApiCalled = false;
        const { userType, userId, visitId } = this.props.match.params;
        console.log('ActiveVisit: constructor - initial loader state', {
            isInitialCallLoader: this.state.isInitialCallLoader,
            userType,
            visitId,
        });
        if (userType === Patient || userType === Student) {
            if (_.size(this.props.videoCallDetails) === 0) {
                this.props.history.push(`${PATH.IM_PATIENT.WAITINGROOM}/${userId}/${visitId}`);
            }
        }
        if (userType === LevelTwoAdmin) {
            if (_.size(this.props.videoCallDetails) === 0) {
                this.props.history.push(
                    `${LEVEL_TWO_ADMIN_ROUTES_SECONDARY_PATH.LEVEL_TWO_ADMIN}/${userId}${LEVEL_TWO_ADMIN_ROUTES_SECONDARY_PATH.SUMMARY}/${visitId}`
                );
            }
        }
        myLog('videoCallDetails constructor', this.props.videoCallDetails);
    }

    /**
     * @inheritDoc
     */
    componentDidMount = () => {
        // Display warning if test mode is active
        if (VONAGE_API_TEST_MODE) {
            console.warn('⚠️ ===============================================');
            console.warn('⚠️ VONAGE API TEST MODE ACTIVE');
            console.warn('⚠️ Primary credentials will be IGNORED');
            console.warn('⚠️ Only vonage API credentials will be used');
            console.warn('⚠️ DO NOT USE IN PRODUCTION');
            console.warn('⚠️ ===============================================');
        }
        
        const urlParams = new URLSearchParams(window.location.search);

        const sessionId = urlParams.get('sessionId');
        const token = urlParams.get('token');
        const moderatorToken = urlParams.get('moderatorToken');
        const apiKey = urlParams.get('apiKey');
        const sessionTime = urlParams.get('sessionTime');
        const AnonymousUserId = urlParams.get('userId');
        const AnonymousVisitId = urlParams.get('visitId');
        const AnonymousRole = urlParams.get('role');
        const socketAuthentication = urlParams.get('socketAuthentication');
        const anonymousUser = sessionStorage.getItem('anonymousUser');
        const sessionEndTimeParam = urlParams.get('sessionEndTime');
        const educatorName = urlParams.get('educatorName');
        const sessionTypeParams = urlParams.get('sessionType');
        const createdByUserId = urlParams.get('createdByUserId');

        const whiteboardVisitId = this.props.match.params.visitId || AnonymousVisitId;
        if (whiteboardVisitId) {
            setActiveWhiteboardSession(whiteboardVisitId);
            pruneWhiteboardSessionsExcept(whiteboardVisitId);
        }
        
        this.setState({
            urlParams: {
                sessionId,
                token,
                moderatorToken,
                apiKey,
                sessionTime,
                AnonymousUserId,
                AnonymousRole,
                AnonymousVisitId,
                sessionEndTimeParam,
                educatorName,
                sessionTypeParams,
                createdByUserId,
            },
            isGroupSession: sessionTypeParams === 'Group session',
            isOnetoOne: sessionTypeParams === 'one-to-one',
        });
        setTimeout(() => {
            if (AnonymousRole) {
                const validSocketAuthentication = this.getValidAnonymousValue(socketAuthentication);
                if (validSocketAuthentication) {
                    store.set('socketAuthentication', validSocketAuthentication);
                }
                store.set('AnonymousRole', AnonymousRole);
                // this.setState({ showAnonymousModal: true });
            }
        }, 1000);

        // Checked on every entry, independently of the name form and the early
        // join window - both of those can be skipped, this cannot.
        if (AnonymousRole === Anonymous) {
            this.runVisitStatusGate(AnonymousVisitId);
        }

        // if(this.state.showEarlyJoinModal || this.state.showAnonymousModal) {
        //     this.props.startChatSocketConnect(
        //             urlParams.AnonymousUserId,
        //             Anonymous,
        //             urlParams.AnonymousVisitId,
        //             this.props
        //         );
        // }

        if (sessionTime && AnonymousRole) {
            const sessionTimestamp = parseInt(sessionTime, 10);
            const currentTime = Date.now();
            const timeDiff = sessionTimestamp - currentTime;

            if (timeDiff > 10 * 60 * 1000) {
                this.setState({ showEarlyJoinModal: true, showAnonymousModal: false });

                // Optional: Start polling to remove modal when time is valid
                this.sessionAccessInterval = setInterval(() => {
                    const now = Date.now();
                    if (sessionTimestamp - now <= 10 * 60 * 1000) {
                        this.setState({
                            showEarlyJoinModal: false,
                            showAnonymousModal: true,
                        });
                        clearInterval(this.sessionAccessInterval);
                    }
                }, 10000); // check every 10 seconds
                return; // Stop rest of execution until modal closes
            } else {
                // If timeDiff is already less than or equal to 10 minutes, directly open showAnonymousModal
                if (AnonymousRole && !anonymousUser) {
                    this.setState({ showAnonymousModal: true });
                } else {
                    this.setState({ showAnonymousModal: false });
                }
            }
        }

        // Check session end time immediately
        if (sessionEndTimeParam) {
            const sessionEndTime = parseInt(sessionEndTimeParam, 10);
            const now = Date.now();

            if (now >= sessionEndTime) {
                // Session already ended
                this.props.showNotification('Your session time is ended', 'error');
            } else {
                // Optional: set a timeout to show notification exactly at end time
                const timeUntilEnd = sessionEndTime - now;
                this.sessionEndTimeout = setTimeout(() => {
                    this.props.showNotification('Your session time is ended', 'error');
                }, timeUntilEnd);
            }
        }
        sessionStorage.setItem('messageSeen', false);
        this.setState({
            isClassRoom: sessionStorage.getItem('VISIT_TYPE') === 'class_room' || sessionStorage.getItem('VISIT_TYPE') === 'class_room_session' ? true : false,
            isBroadCast: sessionStorage.getItem('VISIT_TYPE') === 'broadcast' ? true : false,
            isConferenceCall: sessionStorage.getItem('VISIT_TYPE') === 'conference_call' ? true : false,

        });
        clearTimOutInterval();
        window.addEventListener('resize', this.handleResize);
        if (window.innerWidth <= 1024) {
            this.setState({ minWidth: true });
        } else {
            this.setState({ minWidth: false });
        }
        const { userId, userType, visitId } = this.props.match.params;

        const startVideoSession = () => {
            const visitType = sessionStorage.getItem('VISIT_TYPE');
            const sessionType = sessionStorage.getItem('SESSION_TYPE');
            const isInPersonOneToOne = visitType === 'one_to_one' && sessionType === 'IN_PERSON';

            if (isInPersonOneToOne && userType === Tutor) {
                this.props.joinInPersonSession(visitId, (response) => {});
            }

            if (userType === Tutor) {
                this.props.startChatSocketConnect(userId, Doctor, visitId, this.props);
            } else if (userType === LevelTwoAdmin) {
                this.props.startChatSocketConnect(
                    userId,
                    RESPONSE_CONSTANT.LEVEL_TWO_ADMIN,
                    visitId,
                    this.props
                );
            } else if (AnonymousRole === Anonymous) {
                const anonymousUser = store.get('anonymousUser');
                if (anonymousUser) {
                    // Fetch session details for anonymous user with saved details (on page refresh)
                    const [firstName, ...lastNameParts] = anonymousUser.split(' ');
                    const lastName = lastNameParts.join(' ');
                    const values = {
                        firstName: firstName || '',
                        lastName: lastName || '',
                        userId: AnonymousUserId,
                        visitId: AnonymousVisitId,
                    };
                    
                    this.props.anonymousUserDetails(values, (response) => {
                        if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                            const anonymousCredentials = this.resolveAnonymousCredentials(response);

                            this.props.startChatSocketConnect(
                                anonymousCredentials.userId || AnonymousUserId,
                                Anonymous,
                                AnonymousVisitId,
                                this.props
                            );

                            this.setState({
                                sessionUsers: response.response?.sessionUsers,
                                externalUsersDetails: response.response?.externalUsersDetails || [],
                            }, () => {
                                // PRODUCTION FIX: Cache initial session data for fallback matching
                                try {
                                    const dataToCache = {
                                        sessionUsers: response.response?.sessionUsers || [],
                                        externalUsersDetails: response.response?.externalUsersDetails || [],
                                        timestamp: Date.now()
                                    };
                                    sessionStorage.setItem('currentSessionData', JSON.stringify(dataToCache));
                                    // console.log('💾 [Initial Load] Cached session data for fallback matching:', {
                                    //     sessionUsersCount: dataToCache.sessionUsers.length,
                                    //     externalUsersCount: dataToCache.externalUsersDetails.length
                                    // });
                                } catch (e) {
                                    console.error('❌ [Initial Load] Failed to cache session data:', e);
                                }
                                
                                // After session data is loaded, emit stream ID if other users present
                                if (this.OpenTok?.emitStreamId) {
                                    setTimeout(() => {
                                        this.OpenTok.emitStreamId();
                                    }, 500);
                                }
                            });
                            // console.log('[Anonymous User] Fetched session details on page load', {
                            //     sessionUsers: response.response?.sessionUsers?.length || 0,
                            //     externalUsersDetails: response.response?.externalUsersDetails?.length || 0,
                            // });
                        }
                    });
                } else {
                    console.warn('Anonymous user not ready yet.');
                }
            } else {
                this.props.startChatSocketConnect(userId, Patient, visitId, this.props);
            }
            if (this.props.isRecordingCall) {
                this.invokeStartRecord();
            }
            if (_.size(this.props.videoCallDetails) !== 0) {
                this.invokeChatList(this.state.currentChatPage);
            } else if (userType === Doctor || userType === Tutor) {
                this.invokeChatList(this.state.currentChatPage);
            }
            if (userType === Doctor || userType === Tutor) {
                this.invokeGetHandout();
            }
            if (!sessionId && !token && !apiKey) {
                // Set tracked source when credentials are already available at mount time.
                const hasPrimaryCredentials = this.hasPrimaryCredentialsAvailable();
                const hasSocketCredentials = this.hasSocketCredentialsAvailable();

                if (hasPrimaryCredentials) {
                    this.setState({ sessionJoinSource: SESSION_JOIN_SOURCE.PRIMARY_CREDENTIALS });
                    console.log('[Session Join] 🟢 PRIMARY_CREDENTIALS - Using primary credentials immediately');
                } else if (hasSocketCredentials) {
                    this.setState({ sessionJoinSource: SESSION_JOIN_SOURCE.SOCKET_SESSION_DETAILS });
                    console.log('[Session Join] 🟢 SOCKET_SESSION_DETAILS - Using socket credentials immediately');
                }

                // Call the full visit details for other metadata (and fallback credentials)
                this.props.getNewVideoFlowConfig(visitId, (result) => {
                    if (result.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                        // Persist the session's transcription language so the in-person browser
                        // speech recognizer (Publisher) captions in the language selected for
                        // this session, not the domain-level default language. This runs for
                        // every entry path into the call (not just the waiting room).
                        // Healthcare-only feature: core stays on its domain default (English).
                        if (AppConfig.isHealthCare) {
                            sessionStorage.setItem(
                                'SESSION_TRANSCRIPTION_LANGUAGE',
                                result.response?.transcriptionLanguage || ''
                            );
                        }
                        if (
                            result.response?.sessionStatus === 'Note Pending' ||
                            result.response?.sessionStatus === 'Completed'
                        ) {
                            this.props.history.go(-1);
                        } else {
                            this.setState({
                                isAllowAudioVideoChatBtn:
                                    result.response.properties.allowAudioVideoChatBtn,
                                isAllowEndVisitBtn: result.response.properties.allowEndVisitBtn,
                                isVisitCreditAllow: result.response.properties.visitCreditAllow,
                                isVisitEncounterInfoScreen:
                                    result.response.properties.visitEncounterInfoScreen,
                                isVisitInfoWithUserInfoScreen:
                                    result.response.properties.visitInfoWithUserInfoScreen,
                                isShowChatBtn: result.response.properties.showChatBtn,
                                isShowVideoConsultation:
                                    result.response.properties.showVideoConsultation,
                                sessionUsers: result.response?.sessionUsers,
                                externalUsersDetails: result.response?.externalUsersDetails || [],
                                isBroadCastEnable: result.response?.activeSession?.broadcast?.hls
                                    ? true
                                    : false,
                            });
                            // console.log('[Session Init] Loaded from getNewVideoFlowConfig API', {
                            //     sessionUsers: result.response?.sessionUsers?.length || 0,
                            //     externalUsersDetails: result.response?.externalUsersDetails?.length || 0,
                            //     externalUsers: result.response?.externalUsersDetails,
                            // });
                        }
                    }
                });
            }
        };

        if (sessionStorage.getItem(NETWORK_RECONNECT_STOP_BEFORE_INIT_KEY) === 'true' && visitId) {
            sessionStorage.removeItem(NETWORK_RECONNECT_STOP_BEFORE_INIT_KEY);
            let hasStartedVideoSession = false;
            const startVideoSessionOnce = (response, source) => {
                if (hasStartedVideoSession) {
                    return;
                }

                hasStartedVideoSession = true;
                clearTimeout(this.networkReconnectStopTimeout);
                myLog('Network reconnect stopVideoRecord response', { response, source });
                startVideoSession();
            };

            this.networkReconnectStopTimeout = setTimeout(() => {
                startVideoSessionOnce(false, 'timeout');
            }, NETWORK_RECONNECT_STOP_TIMEOUT);

            this.props.stopVideoRecord(visitId, (response) => {
                startVideoSessionOnce(response, 'callback');
            });
            return;
        }

        startVideoSession();
    };

    //componentDidUpdate
    componentDidUpdate(prevProps, prevState) {
        if (
            prevState.mutePublisherVideoClicked !== this.state.mutePublisherVideoClicked ||
            prevState.mutePublisherVoiceClicked !== this.state.mutePublisherVoiceClicked
        ) {
            if (!this.state.mutePublisherVideoClicked && !this.state.mutePublisherVoiceClicked) {
                this.props.history.push(
                    `${PATH.IM_PATIENT.WAITINGROOM}/${this.props.match.params.userId}/${this.props.match.params.visitId}`
                );
            }
        }
        if (prevProps.showWhiteboard !== this.props.showWhiteboard) {
            console.log('Parent showWhiteboard changed:', this.props.showWhiteboard);
        }
        if (!prevProps.isRecordingCall && this.props.isRecordingCall) {
            this.invokeStartRecord(); // already includes 2s delay
        }
        
        // Track if any user lists changed (deduplicate emit calls)
        let shouldEmitStreamId = false;
        let shouldEmitStreamIdImmediately = false;
        
        // Update sessionUsers when studentDetails changes (from socket new_session_details)
        if (
            this.props.studentDetails?.sessionUsers &&
            JSON.stringify(prevProps.studentDetails?.sessionUsers) !==
                JSON.stringify(this.props.studentDetails?.sessionUsers)
        ) {
            // Check if there are NEW user IDs (not just same users rejoining)
            const prevUserIds = new Set(prevProps.studentDetails?.sessionUsers?.map(u => u.userId) || []);
            const currentUserIds = new Set(this.props.studentDetails.sessionUsers.map(u => u.userId));
            const newUserIds = [...currentUserIds].filter(id => !prevUserIds.has(id));
            const isRejoin = newUserIds.length === 0 && currentUserIds.size > prevUserIds.size;
            
            // console.log('📊 [componentDidUpdate] props.studentDetails.sessionUsers CHANGED:', {
            //     previousCount: prevProps.studentDetails?.sessionUsers?.length || 0,
            //     currentCount: this.props.studentDetails.sessionUsers.length,
            //     previousUserIds: Array.from(prevUserIds),
            //     currentUserIds: Array.from(currentUserIds),
            //     newUserIds: Array.from(newUserIds),
            //     isRejoin,
            //     users: this.props.studentDetails.sessionUsers.map(u => ({
            //         userId: u.userId,
            //         name: u.name,
            //         hasUserId: !!u.userId
            //     }))
            // });
            
            this.setState({
                sessionUsers: this.props.studentDetails.sessionUsers,
            });
            
            // PRODUCTION FIX: Cache updated session data for fallback matching
            try {
                const dataToCache = {
                    sessionUsers: this.props.studentDetails.sessionUsers || [],
                    externalUsersDetails: this.state.externalUsersDetails || [],
                    timestamp: Date.now()
                };
                sessionStorage.setItem('currentSessionData', JSON.stringify(dataToCache));
                // console.log('💾 [Props Update] Cached sessionUsers update');
            } catch (e) {
                console.error('❌ [Props Update] Failed to cache sessionUsers:', e);
            }
            
            // console.log('[Session Details] SessionUsers changed - re-emitting streamIds', {
            //     newUserIds: newUserIds.length > 0 ? newUserIds : 'none (rejoin or update)',
            //     total: this.props.studentDetails.sessionUsers.length,
            //     isRejoin,
            // });
            // Always re-emit on ANY sessionUsers change (join, rejoin, or update)
            // This fixes the rejoin bug where existing participants wouldn't re-sync
            shouldEmitStreamId = true;
            
            // For rejoins, emit immediately without delay to ensure rejoining user receives mappings
            if (isRejoin) {
                shouldEmitStreamIdImmediately = true;
            }
        }
        
        // Update externalUsersDetails when studentDetails changes (from socket new_session_details)
        if (
            this.props.studentDetails?.externalUsersDetails &&
            JSON.stringify(prevProps.studentDetails?.externalUsersDetails) !==
                JSON.stringify(this.props.studentDetails?.externalUsersDetails)
        ) {
            // Check if there are NEW user IDs (not just same users rejoining)
            const prevUserIds = new Set(prevProps.studentDetails?.externalUsersDetails?.map(u => u.userId) || []);
            const currentUserIds = new Set(this.props.studentDetails.externalUsersDetails.map(u => u.userId));
            const newUserIds = [...currentUserIds].filter(id => !prevUserIds.has(id));
            const isRejoin = newUserIds.length === 0 && currentUserIds.size > prevUserIds.size;
            
            // console.log('📊 [componentDidUpdate] props.studentDetails.externalUsersDetails CHANGED:', {
            //     previousCount: prevProps.studentDetails?.externalUsersDetails?.length || 0,
            //     currentCount: this.props.studentDetails.externalUsersDetails.length,
            //     previousUserIds: Array.from(prevUserIds),
            //     currentUserIds: Array.from(currentUserIds),
            //     newUserIds: Array.from(newUserIds),
            //     isRejoin,
            //     users: this.props.studentDetails.externalUsersDetails.map(u => ({
            //         userId: u.userId,
            //         name: u.name,
            //         hasUserId: !!u.userId,
            //         allKeys: Object.keys(u)
            //     })),
            //     WARNING: currentUserIds.has(undefined) ? '⚠️ UNDEFINED userId DETECTED!' : 'All userIds valid'
            // });
            
            this.setState({
                externalUsersDetails: this.props.studentDetails.externalUsersDetails,
            });
            
            // PRODUCTION FIX: Cache updated session data for fallback matching
            try {
                const dataToCache = {
                    sessionUsers: this.state.sessionUsers || [],
                    externalUsersDetails: this.props.studentDetails.externalUsersDetails || [],
                    timestamp: Date.now()
                };
                sessionStorage.setItem('currentSessionData', JSON.stringify(dataToCache));
                // console.log('💾 [Props Update] Cached externalUsersDetails update');
            } catch (e) {
                console.error('❌ [Props Update] Failed to cache externalUsersDetails:', e);
            }
            
            // console.log('[Session Details] ExternalUsersDetails changed - re-emitting streamIds', {
            //     newUserIds: newUserIds.length > 0 ? newUserIds : 'none (rejoin or update)',
            //     total: this.props.studentDetails.externalUsersDetails.length,
            //     isRejoin,
            // });
            // Always re-emit on ANY externalUsersDetails change (join, rejoin, or update)
            shouldEmitStreamId = true;
            
            // For rejoins, emit immediately without delay
            if (isRejoin) {
                shouldEmitStreamIdImmediately = true;
            }
        }
        
        // Emit stream ID only once if there are new users (deduplicated across both arrays)
        if (shouldEmitStreamId && this.OpenTok?.emitStreamId) {
            // console.log('✅ [componentDidUpdate] Triggering emitStreamId:', {
            //     immediate: shouldEmitStreamIdImmediately,
            //     delay: shouldEmitStreamIdImmediately ? 0 : 200,
            //     hasOpenTok: !!this.OpenTok,
            //     hasEmitMethod: !!this.OpenTok?.emitStreamId,
            //     currentState: {
            //         sessionUsers: this.state.sessionUsers?.length || 0,
            //         externalUsersDetails: this.state.externalUsersDetails?.length || 0
            //     }
            // });
            
            if (shouldEmitStreamIdImmediately) {
                // Immediate emission for rejoin scenarios - critical for syncing with rejoining user
                // console.log('[Session Details] Immediate streamId re-emission (rejoin detected)');
                this.OpenTok.emitStreamId();
            } else {
                // Reduced delay for new user joins (was 500ms, now 200ms)
                // console.log('[Session Details] Delayed streamId re-emission (new user join)');
                setTimeout(() => {
                    this.OpenTok.emitStreamId();
                }, 200);
            }
        } else if (shouldEmitStreamId && !this.OpenTok?.emitStreamId) {
            console.warn('⚠️ [componentDidUpdate] Cannot emit - OpenTok.emitStreamId not available', {
                hasOpenTok: !!this.OpenTok,
                openTokKeys: this.OpenTok ? Object.keys(this.OpenTok) : 'no OpenTok'
            });
        }

        // Resolve tracked source as soon as credentials become available,
        // and cancel any pending fallback wait to avoid misleading logs.
        if (this.state.sessionJoinSource === SESSION_JOIN_SOURCE.NONE) {
            if (this.hasPrimaryCredentialsAvailable()) {
                if (this.sessionFallbackRequested) {
                    clearTimeout(this.sessionFallbackTimeout);
                    this.sessionFallbackRequested = false;
                    console.log('[Session Join] ⏹️ Cancelled fallback wait - PRIMARY_CREDENTIALS available');
                }
                this.setState({ sessionJoinSource: SESSION_JOIN_SOURCE.PRIMARY_CREDENTIALS });
                return;
            }

            if (this.hasSocketCredentialsAvailable()) {
                if (this.sessionFallbackRequested) {
                    clearTimeout(this.sessionFallbackTimeout);
                    this.sessionFallbackRequested = false;
                    console.log('[Session Join] ⏹️ Cancelled fallback wait - SOCKET_SESSION_DETAILS available');
                }
                this.setState({ sessionJoinSource: SESSION_JOIN_SOURCE.SOCKET_SESSION_DETAILS });
            }
        }
        
        // Check for pending stream re-emission flag (set by new_session_details socket event)
        // This handles race condition where stream arrives BEFORE user data
        const pendingReEmission = sessionStorage.getItem('pendingStreamReEmission');
        if (pendingReEmission === 'true') {
            // Clear the flag immediately to prevent repeated emissions
            sessionStorage.removeItem('pendingStreamReEmission');
            
            // console.log('🔄 [componentDidUpdate] Pending stream re-emission detected - triggering now', {
            //     hasOpenTok: !!this.OpenTok,
            //     hasEmitMethod: !!this.OpenTok?.emitStreamId,
            //     sessionUsersCount: this.state.sessionUsers?.length || 0,
            //     externalUsersCount: this.state.externalUsersDetails?.length || 0
            // });
            
            // Re-emit all streamIds after a short delay to ensure state has settled
            if (this.OpenTok?.emitStreamId) {
                setTimeout(() => {
                    // console.log('🔄 [Delayed Re-Emission] Executing stream re-emission after new_session_details');
                    this.OpenTok.emitStreamId();
                    // Clear hasUnmatchedStreams flag after re-emission (will be reset if still unmatched)
                    sessionStorage.removeItem('hasUnmatchedStreams');
                }, 300);
            } else {
                console.warn('⚠️ [componentDidUpdate] Cannot re-emit - OpenTok.emitStreamId not available');
            }
        }
    }

    hasPrimaryCredentialsAvailable = () => {
        const details = this.props.videoCallDetails || {};
        const hasTopLevelPrimary =
            !!details.apikey && !!details.opentokSession && !!details.opentokToken;
        const hasActiveSessionPrimary =
            !!details.activeSession?.apikey &&
            !!details.activeSession?.opentokSession &&
            !!details.activeSession?.opentokToken;

        return hasTopLevelPrimary || hasActiveSessionPrimary;
    };

    hasSocketCredentialsAvailable = () => {
        const socketCredentials =
            this.props.vonage_session_details || this.props.videoCallDetails?.vonage_session_details;

        return (
            !!socketCredentials?.apiKey &&
            !!socketCredentials?.sessionId &&
            !!socketCredentials?.token
        );
    };

    // getEffectiveVisitId
    // The third party route is plain /video and carries no route params, so its
    // visit id comes from the join link instead.
    getEffectiveVisitId = () =>
        this.props.match.params.visitId || this.state.urlParams?.AnonymousVisitId;

    getValidAnonymousValue = (value) => {
        if (value === null || value === undefined) {
            return '';
        }

        const normalizedValue = String(value).trim();
        return normalizedValue && normalizedValue !== 'null' && normalizedValue !== 'undefined'
            ? normalizedValue
            : '';
    };

    getAnonymousCredentialsFromResponse = (response) => {
        const responseData = response?.response || {};
        const externalUserDetails = Array.isArray(responseData.externalUsersDetails)
            ? responseData.externalUsersDetails[0]
            : null;

        return {
            userId:
                this.getValidAnonymousValue(responseData.externalId) ||
                this.getValidAnonymousValue(externalUserDetails?.externalId),
            socketAuthentication:
                this.getValidAnonymousValue(responseData.socketAuthKey) ||
                this.getValidAnonymousValue(externalUserDetails?.socketAuthKey),
        };
    };

    resolveAnonymousCredentials = (response) => {
        const { userId, socketAuthentication } = this.getAnonymousCredentialsFromResponse(response);
        const resolvedUserId = this.getValidAnonymousValue(this.state.urlParams?.AnonymousUserId) || userId;
        const resolvedSocketAuthentication =
            this.getValidAnonymousValue(store.get('socketAuthentication')) ||
            this.getValidAnonymousValue(new URLSearchParams(window.location.search).get('socketAuthentication')) ||
            socketAuthentication;

        if (resolvedUserId || resolvedSocketAuthentication) {
            this.setState((prevState) => ({
                urlParams: {
                    ...prevState.urlParams,
                    AnonymousUserId: resolvedUserId || prevState.urlParams?.AnonymousUserId,
                },
            }));
        }

        if (resolvedUserId) {
            store.set('userId', resolvedUserId);
        }

        if (resolvedSocketAuthentication) {
            store.set('socketAuthentication', resolvedSocketAuthentication);
            window.sessionStorage.setItem('socketAuthenticationParams', resolvedSocketAuthentication);
        }

        return {
            userId: resolvedUserId,
            socketAuthentication: resolvedSocketAuthentication,
        };
    };

    triggerSessionFallbackIfNeeded = (visitId, renderScope) => {
        // 1) Primary first
        if (this.hasPrimaryCredentialsAvailable()) {
            if (this.state.sessionJoinSource !== SESSION_JOIN_SOURCE.PRIMARY_CREDENTIALS) {
                this.setState({ sessionJoinSource: SESSION_JOIN_SOURCE.PRIMARY_CREDENTIALS });
            }
            return;
        }

        // 2) Then socket credentials
        if (this.hasSocketCredentialsAvailable()) {
            if (this.state.sessionJoinSource !== SESSION_JOIN_SOURCE.SOCKET_SESSION_DETAILS) {
                this.setState({ sessionJoinSource: SESSION_JOIN_SOURCE.SOCKET_SESSION_DETAILS });
            }
            return;
        }

        // 3) If neither available, start a single 3-second fallback timer
        if (!visitId) {
            // There is nothing to ask the API for, and sending the string
            // "undefined" is rejected by the endpoint.
            console.warn(
                `[Session Join][${renderScope}] No visit id available - skipping API fallback`
            );
            return;
        }
        if (this.sessionFallbackRequested || this.sessionFallbackApiCalled) {
            return;
        }

        this.sessionFallbackRequested = true;
        // console.log(`[Session Join][${renderScope}] 🟡 Waiting 3s for PRIMARY_CREDENTIALS or SOCKET_SESSION_DETAILS`);

        this.sessionFallbackTimeout = setTimeout(() => {
            this.sessionFallbackRequested = false;

            const hasPrimaryCredentialsAfterWait = this.hasPrimaryCredentialsAvailable();
            const hasSocketCredentialsAfterWait = this.hasSocketCredentialsAvailable();

            if (hasPrimaryCredentialsAfterWait) {
                this.setState({ sessionJoinSource: SESSION_JOIN_SOURCE.PRIMARY_CREDENTIALS });
                console.log(`[Session Join][${renderScope}] 🟢 PRIMARY_CREDENTIALS became available within 3s`);
                return;
            }

            if (hasSocketCredentialsAfterWait) {
                this.setState({ sessionJoinSource: SESSION_JOIN_SOURCE.SOCKET_SESSION_DETAILS });
                console.log(`[Session Join][${renderScope}] 🟢 SOCKET_SESSION_DETAILS became available within 3s`);
                return;
            }


            this.sessionFallbackApiCalled = true;
            this.setState({ sessionJoinSource: SESSION_JOIN_SOURCE.SESSION_API_FALLBACK });
            console.log(`🔵 [${renderScope}] Triggering API FALLBACK - GET /vonage-session/${visitId}`);

            this.props.getVonageSessionDetails(visitId, (vonageResult) => {
                const isSuccess = vonageResult && vonageResult.code === RESPONSE_CONSTANT.SUCCESS_CODE;
                const hasValidCredentials =
                    isSuccess &&
                    vonageResult.response?.apikey &&
                    vonageResult.response?.opentokSession &&
                    vonageResult.response?.opentokToken;

                if (isSuccess && hasValidCredentials) {
                    console.log(`✅ [${renderScope}] API FALLBACK SUCCESS - credentials stored`);
                } else {
                    console.warn(`❌ [${renderScope}] API FALLBACK FAILED - no valid credentials`);
                }
            });
        }, 3000);
    };

    /**
     * @inheritDoc
     */
    componentWillUnmount = () => {
        // Log final session details for analytics and debugging
        console.log('[Session Join] 📊 Session ending - tracking final metrics', {
            sessionJoinSource: this.state.sessionJoinSource,
            visitId: this.props.match.params.visitId,
            userType: this.props.match.params.userType,
            sessionDuration: Date.now() - this.sessionStartTime,
        });
        
        // Clear anonymous user data from storage when leaving session
        const urlParams = new URLSearchParams(window.location.search);
        const AnonymousRole = urlParams.get('role');
        if (AnonymousRole === Anonymous) {
            store.remove('anonymousUser');
            store.remove('AnonymousRole');
            store.remove('userId');
            store.remove('visitId');
            store.remove('socketAuthentication');
            store.remove('socketAuthenticationParams');
            // console.log('[Anonymous User] Cleared all anonymous storage on session end');
        }
        
        this.setState({
            mutePublisherVideoClicked: false,
            mutePublisherVoiceClicked: false,
        });
        this.props.endVideoChatClear();
        resetTimeOutInterval();
        clearTimeout(this.timer);
        clearTimeout(this.closeTabTimer);
        clearTimeout(this.sessionFallbackTimeout);
        clearTimeout(this.networkReconnectStopTimeout);
        this.props.stopChatSocketConnect();
        if (this.props.match.params.userType === Tutor) {
            this.invokeStopRecord();
        }
        if (sessionStorage.getItem('messageSeen') === 'true') {
            this.props.clearUnreadCount();
        }
        sessionStorage.setItem('messageSeen', false);
    };

    // handleResize
    handleResize = () => {
        this.setState({
            windowHeight: window.innerHeight,
            windowWidth: window.innerWidth,
        });
        if (window.innerWidth <= 1024) {
            this.setState({ minWidth: true });
        } else {
            this.setState({ minWidth: false });
        }
    };

    // invokeGetHandout
    invokeGetHandout = () => {
        this.props.getHandout((response) => {
            if (response) {
                if (response.code !== RESPONSE_CONSTANT.SUCCESS_CODE) {
                    this.props.showNotification(response.response_message, 'error');
                }
            }
        });
    };

    // getVisitEncounter
    getVisitEncounter(visitId) {
        this.props.getPatientVisitEncounter(visitId, (callback) => {
            myLog('callback', callback);
        });
    }

    // showVideo
    showVideo() {
        this.setState({
            messageClicked: false,
        });
    }

    // invokeKidInfo
    invokeKidInfo = () => {
        const { visitId } = this.props.match.params;
        this.props.getKidInfo(visitId, (res) => {
            if (res.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                this.setState({
                    studentDetails: res.response.tutee,
                    studentName: res.response.tutee.name,
                    grade: res.response.isParent
                        ? res.response.kid && res.response.kid.grade
                        : res.response.tutee.grade,
                    isParent: res.response.isParent,
                    kidName: res.response.kid && res.response.kid.name,
                });
            }
        });
    };

    //_renderAddress
    _renderAddress(videoCallDetails) {
        const { dateOfBirth, gender } = videoCallDetails;
        if (typeof dateOfBirth !== 'undefined' || typeof gender !== 'undefined') {
            return this.state.isParent !== true ? null : dateOfBirth === '' ? null : (
                <>
                    <b style={{ color: '#fff' }}>Kid Detail:</b>
                    <p className="text-white">
                        Kid Name:<b>{this.state.kidName}</b>
                    </p>
                    <p className="text-white">
                        Grade:<b>{this.state.grade}</b>
                    </p>
                </>
            );
        }
    }

    //closeMessagePop
    closeMessagePop() {
        this.setState({
            showMessagePop: false,
        });
    }

    //openMessagePop
    openMessagePop() {
        this.setState({
            showMessagePop: true,
            showParticipants: false,
        });
        this.props.clearUnreadCount();
    }

    //toggleParticipantsPop
    toggleParticipantsPop() {
        this.setState({
            showMessagePop: false,
            showParticipants: !this.state.showParticipants,
            activeTab:
                this.state.isClassRoom || this.state.isBroadCast || this.state.isGroupSession || this.state.isConferenceCall
                    ? 'participants'
                    : 'sessionNotes',
        });
    }

    /**
     * get chat list from webservice
     */
    invokeChatList(pageNumber) {
        const { userType, visitId } = this.props.match.params;
        let url = IM_PHYSICIAN.VISIT_CHAT_LIST;
        if (userType === Patient || userType === Student) {
            url = IM_PATIENT.VISIT_CHAT_LIST;
        }
        const values = {
            sort: 'asc',
            pageNumber: pageNumber + 1,
            itemsPerPage: 99999,
            isSysNotificationReqd: false,
        };
        this.props.getVideoChat(url, visitId, values, (response) => {
            if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                this.setState({
                    chatLastPage: response.response.totalPages ? response.response.totalPages : 0,
                    currentChatPage: this.state.currentChatPage + 1,
                });
            }
        });
    }

    /**
     * start record webservice called
     */
    invokeStartRecord = () => {
        const { isRecordingCall, match, startVideoRecord } = this.props;

        const { visitId } = match.params;

        if (!isRecordingCall || !visitId) return;

        setTimeout(() => {
            startVideoRecord(visitId, (response) => {
                myLog('Video recording started:', response);
            });
        }, 2000); // 2-second delay
    };

    /**
     * start record webservice called
     */
    invokeStopRecord() {
        const { visitId } = this.props.match.params;
        this.props.stopVideoRecord(visitId, (callback) => {
            myLog('callback', callback);
        });
    }

    /**
     * Record Button Clicked
     */
    onRecordClicked() {
        const { isRecording } = this.props;
        if (isRecording) {
            this.invokeStopRecord();
        } else {
            this.invokeStartRecord();
        }
    }
    /**
     * Socket invoke for send message
     * @param {*} textMessage
     * @param {*} chatImage
     * @param {*} havingImage
     */
    invokeonSendMessage(textMessage, chatImage, havingImage, receiverId) {
        const input = {
            textMessage,
            chatImage,
            havingImage,
            receiverId,
        };
        this.props.onSendMessage(input, (callBack) => {
            myLog('response', callBack);
        });
    }

    /**
     * End Video Call Webservice call
     * @param {*} visitId
     */
    showEndCallFailure = (response) => {
        const message =
            response && typeof response === 'object' && response.message
                ? response.message
                : 'Unable to end the session. Please try again.';

        this.props.showNotification(message, RESPONSE_CONSTANT.ERROR);
    };

    endCallWebservice = (visitId, isCallSuccessful, isVisitCredit) => {
        const { userType } = this.props.match.params;
        clearWhiteboardDataForSession(visitId);
        if (userType === Patient || userType === Student) {
            this.setState({
                endVideoCallModal: false,
                showTimer: false,
            });
            this.props.onPatientEndCall(visitId, (callback) => {
                if (callback) {
                    this.props.showNotification(this.props.t('callEndedSuccessfully'), 'success');
                    resetTimeOutInterval();
                    // Patient/Student leaves can be resumed; do not mark summary as pending.
                    sessionStorage.removeItem('LAST_VISITED_SESSION_ID');
                    sessionStorage.removeItem('MEETING_SUMMARY_PENDING');
                    sessionStorage.removeItem('MEETING_SUMMARY_PENDING_AT');
                    this.props.history.push(
                        `${PATH.IM_PATIENT.APPOINTMENT}/${this.props.match.params.userId}`
                    );
                    window.location.reload();
                }
            });
        } else if (
            (userType === Doctor || userType === Tutor) &&
            this.props.studentDetails?.tutor?.userId ===
                JSON.parse(sessionStorage.getItem('userSession')).id
        ) {
            this.setState({
                showTimer: false,
            });
            this.props.endVideoCall(visitId, isCallSuccessful, isVisitCredit, (callback) => {
                if (callback === true) {
                    this.setState({
                        endVideoCallModal: false,
                    });
                    sessionStorage.removeItem('userId');
                    sessionStorage.removeItem('visitId');
                    sessionStorage.removeItem('VISIT_TYPE');
                    sessionStorage.removeItem('SESSION_TYPE');
                    sessionStorage.removeItem('SESSION_TRANSCRIPTION_LANGUAGE');
                    this.props.showNotification(this.props.t('callEndedSuccessfully'), 'success');
                    resetTimeOutInterval();
                    setMeetingSummaryPendingForSession(visitId);
                    this.props.history.push(
                        `${PATH.IM_PHYSICIAN.APPOINTMENT}/${this.props.match.params.userId}`
                    );
                    window.location.reload();
                } else {
                    this.setState({
                        showTimer: true,
                    });
                    this.showEndCallFailure(callback);
                }
            });
        } else {
            this.setState({
                endVideoCallModal: false,
                showTimer: false,
            });
            this.props.showNotification(this.props.t('callEndedSuccessfully'), 'success');
            // Non-owner leave flow: user can rejoin until owner ends the session.
            sessionStorage.removeItem('LAST_VISITED_SESSION_ID');
            sessionStorage.removeItem('MEETING_SUMMARY_PENDING');
            sessionStorage.removeItem('MEETING_SUMMARY_PENDING_AT');
            this.props.history.push(
                `${PATH.IM_PHYSICIAN.APPOINTMENT}/${this.props.match.params.userId}`
            );
        }
    };

    //endCallWebserviceWithBuffer
    endCallWebserviceWithBuffer = (visitId, isCallSuccessful, isVisitCredit) => {
        const { userType } = this.props.match.params;
        clearWhiteboardDataForSession(visitId);
        if (userType === Patient || userType === Student) {
            this.setState({
                endVideoCallFinalBufferAlert: false,
            });
            resetTimeOutInterval();
            // Patient/Student leaves can be resumed; do not mark summary as pending.
            sessionStorage.removeItem('LAST_VISITED_SESSION_ID');
            sessionStorage.removeItem('MEETING_SUMMARY_PENDING');
            sessionStorage.removeItem('MEETING_SUMMARY_PENDING_AT');
            this.props.history.push(
                `${PATH.IM_PATIENT.APPOINTMENT}/${this.props.match.params.userId}`
            );
        } else if (userType === Doctor || userType === Tutor) {
            this.setState({
                endVideoCallFinalBufferAlert: false,
            });
            this.props.endVideoCall(visitId, isCallSuccessful, isVisitCredit, (callback) => {
                if (callback === true) {
                    this.props.showNotification(this.props.t('callEndedSuccessfully'), 'success');
                    resetTimeOutInterval();
                    if (
                        this.props.studentDetails?.tutor?.userId ===
                        JSON.parse(sessionStorage.getItem('userSession')).id
                    ) {
                        setMeetingSummaryPendingForSession(visitId);
                    } else {
                        // Non-owner leave flow: user can rejoin until owner ends the session.
                        sessionStorage.removeItem('LAST_VISITED_SESSION_ID');
                        sessionStorage.removeItem('MEETING_SUMMARY_PENDING');
                        sessionStorage.removeItem('MEETING_SUMMARY_PENDING_AT');
                    }
                    this.props.history.push(
                        `${PATH.IM_PHYSICIAN.APPOINTMENT}/${this.props.match.params.userId}`
                    );
                } else {
                    this.showEndCallFailure(callback);
                }
            });
        }
    };

    // leaveAnonymousSession
    // Third party (anonymous) participants have no visit to end - they simply
    // disconnect from the session and their tab is closed.
    leaveAnonymousSession = () => {
        const sessionHelper = this.OpenTok && this.OpenTok.sessionHelper;
        store.remove('anonymousUser');
        store.remove('AnonymousRole');
        store.remove('userId');
        store.remove('visitId');
        store.remove('socketAuthentication');
        store.remove('socketAuthenticationParams');
        // Leave the session straight away so the host sees the participant go,
        // then hold the confirmation popup up briefly before closing the tab.
        // Disconnect the session itself rather than the opentok-react helper:
        // the helper nulls out its own `session`, and that null would then
        // propagate down to the publisher and subscribers still mounted behind
        // the popup. The helper's own disconnect still runs on unmount.
        if (sessionHelper && sessionHelper.session) {
            sessionHelper.session.disconnect();
        }
        this.setState({ hasLeftSession: true }, () => {
            this.closeTabTimer = setTimeout(() => {
                this.closeSessionTab();
            }, LEFT_SESSION_CLOSE_DELAY);
        });
    };

    // closeSessionTab
    // A browser only closes a tab that a script opened. A third party opens the
    // invite link themselves, so the browser refuses this and the popup is left
    // up with its "you may close this tab" line. It does close for a tab the
    // app opened through window.open.
    closeSessionTab = () => {
        window.close();
        if (!window.closed) {
            console.warn(
                '[Anonymous User] The browser refused to close this tab: it was not opened by a script.'
            );
        }
    };

    // endVideoCall
    endVideoCall() {
        clearWhiteboardDataForSession(this.state.videoCallVisitId);
        this.setState({
            endVideoCallModal: !this.state.endVideoCallModal,
        });
    }

    // endVideoCallModal
    // endVideoCallModal = () => {
    //   // const { userType } = this.props.match.params;
    //   return (
    //     <Modal
    //       isOpen={this.state.endVideoCallModal}
    //       overlayClassName={"modal-background z-index-1"}
    //       className={"modal-width-endcall"}
    //       ariaHideApp={false}
    //     >
    //       <div className="relative w-full max-w-2xl max-h-full">
    //         <div className="relative p-6 rounded-lg shadow bg-card">
    //           <div className="flex items-center justify-between mb-6">
    //             <h5 className="w-full text-lg font-medium text-center text-white">
    //               End {Visit}
    //             </h5>
    //             <button
    //               type="button"
    //               onClick={() => {
    //                 this.setState({
    //                   endVideoCallModal: !this.state.endVideoCallModal,
    //                 });
    //               }}
    //             >
    //               <svg
    //                 width="18"
    //                 height="18"
    //                 viewBox="0 0 18 18"
    //                 fill="none"
    //                 xmlns="http://www.w3.org/2000/svg"
    //               >
    //                 <path
    //                   d="M13.5 4.5L4.5 13.5M4.5 4.5L13.5 13.5"
    //                   stroke="#B9B9B9"
    //                   strokeWidth="1.5"
    //                   strokeLinecap="round"
    //                   strokeLinejoin="round"
    //                 />
    //               </svg>
    //             </button>
    //           </div>
    //           <div className="text-center">
    //             <span className="text-UIsecondary">
    //               Once you leave the{" "}
    //               {this.state.isBroadCast ? liveStreamBroadCast : waitingRooms} the
    //               call <br/>will be ended
    //             </span>
    //           </div>
    //           <div className="flex flex-row items-center justify-center gap-4 mt-6">
    //             <button
    //               className="w-full py-1.5 px-3 text-white font-semibold rounded-lg bg-black"
    //               onClick={() => {
    //                 this.setState({
    //                   endVideoCallModal: !this.state.endVideoCallModal,
    //                 });
    //               }}
    //             >
    //               Cancel
    //             </button>
    //             <button
    //               className="w-full py-2 text-base font-semibold text-white rounded-lg bg-danger"
    //               onClick={() =>
    //                 this.endCallWebservice(this.state.videoCallVisitId)
    //               }
    //               disabled={this.state.isdisable ? "disabled" : null}
    //             >
    //               End {Visit}
    //             </button>
    //           </div>
    //         </div>
    //       </div>
    //     </Modal>
    //   );
    // };
    endVideoCallModal = () => {
        const { userType } = this.props.match.params;
        const { isEndCallLoading } = this.props;
        const isEndCallButtonLoading = isEndCallLoading;
        return (
            <Modal
                isOpen={this.state.endVideoCallModal}
                overlayClassName={'modal-background z-index-1'}
                className={'modal-width-endcall'}
                ariaHideApp={false}
            >
                <div className="relative w-full max-w-2xl max-h-full">
                    <div className="relative p-6 rounded-lg shadow bg-card">
                        <div className="flex items-center justify-between mb-6">
                            <h5 className="w-full text-lg font-medium text-center text-white">
                                {this.props.t('endVisit')} {this.props.t('visit')}
                            </h5>
                            <button
                                type="button"
                                disabled={isEndCallLoading ? 'disabled' : null}
                                onClick={() => {
                                    this.setState({
                                        endVideoCallModal: !this.state.endVideoCallModal,
                                    });
                                }}
                            >
                                <svg
                                    className="styles_closeIcon__1QwbI"
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="28"
                                    height="28"
                                    viewBox="0 0 36 36"
                                >
                                    <path
                                        d="M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z"
                                        fill="white"
                                    ></path>
                                </svg>
                            </button>
                        </div>
                        {userType === Doctor ||
                        (userType === Tutor &&
                            this.props.studentDetails?.tutor?.userId ===
                                JSON.parse(sessionStorage.getItem('userSession')).id) ? (
                            <div>
                                <div>
                                    <div className="text-center">
                                        <span className="text-base text-UIsecondary">
                                            {this.props.t('onceYouLeaveCall')}{' '}
                                            {this.state.isBroadCast
                                                ? liveStreamBroadCast
                                                : this.props.t('visit')}
                                            ,{this.props.t('theCallWillBeEnded')}
                                        </span>
                                    </div>
                                </div>
                                <div className="flex flex-row items-center justify-end gap-4 mt-6">
                                    <button
                                        className="w-full py-2 text-base font-medium text-white break-normal bg-black rounded-lg"
                                        disabled={isEndCallLoading ? 'disabled' : null}
                                        onClick={() => {
                                            this.setState({
                                                endVideoCallModal: !this.state.endVideoCallModal,
                                            });
                                        }}
                                    >
                                        {this.props.t('cancel')}
                                    </button>
                                    {this.state.isVisitCreditAllow && (
                                        <button
                                            className="w-full py-2 text-base font-semibold break-normal rounded-lg text-primary border-primary ring-1 ring-inset ring-primary sm:w-3/12"
                                            onClick={() => {
                                                this.setState({
                                                    endVideoCallModal:
                                                        !this.state.endVideoCallModal,
                                                });
                                            }}
                                        >
                                            {this.props.t('clickHereIssueCredit')}{' '}
                                            {this.props.t('visit')} {this.props.t('credit')}
                                        </button>
                                    )}
                                    <button
                                        className="relative w-full py-2 text-base font-medium text-white rounded-lg bg-danger"
                                        onClick={() =>
                                            this.endCallWebservice(this.state.videoCallVisitId)
                                        }
                                        disabled={
                                            this.state.isdisable || isEndCallButtonLoading
                                                ? 'disabled'
                                                : null
                                        }
                                    >
                                        <span
                                            style={{
                                                visibility: isEndCallButtonLoading
                                                    ? 'hidden'
                                                    : 'visible',
                                            }}
                                        >
                                            {this.props.t('endVisit')} {this.props.t('visit')}
                                        </span>
                                        {isEndCallButtonLoading && (
                                            <span className="absolute inset-0 flex items-center justify-center">
                                                <Spinner size={18} color="#FFF" />
                                            </span>
                                        )}
                                    </button>
                                </div>
                            </div>
                        ) : (
                            <div>
                                <div className="text-center">
                                    <span className="text-base text-UIsecondary">
                                        {this.props.t('areYouSureLeave')}{' '}
                                        {this.state.isBroadCast
                                            ? liveStreamBroadCast
                                            : waitingRooms}
                                        {this.props.t('youMayResume')}{' '}
                                        {AppConfig.isHealthCare
                                            ? this.props.t('doctor')
                                            : this.props.t('owner')}{' '}
                                        {''}
                                        {this.props.t('concludesIt')}
                                    </span>
                                </div>
                                <div className="flex flex-row items-center justify-end gap-4 mt-6">
                                    <button
                                        className="w-full py-2 text-base font-medium text-white break-normal bg-black rounded-lg"
                                        onClick={() => {
                                            this.setState({
                                                endVideoCallModal: !this.state.endVideoCallModal,
                                            });
                                        }}
                                    >
                                        {this.props.t('cancel')}
                                    </button>
                                    <button
                                        className="w-full py-2 text-base font-medium text-white rounded-lg bg-danger"
                                        onClick={() =>
                                            this.endCallWebservice(this.state.videoCallVisitId)
                                        }
                                        disabled={this.state.isdisable ? 'disabled' : null}
                                    >
                                        {this.props.t('endVisit')} {this.props.t('visit')}
                                    </button>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </Modal>
        );
    };

    // endVideoCallBufferAlertModal
    endVideoCallBufferAlertModal = () => {
        return (
            <Modal
                isOpen={this.state.endVideoCallBufferAlert}
                overlayClassName={'modal-background z-index-1'}
                className={'modal-width-endcall'}
                ariaHideApp={false}
            >
                <div className="relative w-full max-w-2xl max-h-full">
                    <div className="relative p-6 rounded-lg shadow bg-card">
                        <div className="flex items-center justify-between mb-6">
                            <h5 className="text-lg font-medium text-white">
                                {this.props.t('endVisit')} {this.props.t('visit')}
                            </h5>
                            {/* <button
                type="button"
                onClick={() => {
                  this.setState({
                    endVideoCallBufferAlert:
                      !this.state.endVideoCallBufferAlert,
                  });
                }}
              >
                <svg
                  className="styles_closeIcon__1QwbI"
                  xmlns="http://www.w3.org/2000/svg"
                  width="28"
                  height="28"
                  viewBox="0 0 36 36"
                >
                  <path d="M28.5 9.62L26.38 7.5 18 15.88 9.62 7.5 7.5 9.62 15.88 18 7.5 26.38l2.12 2.12L18 20.12l8.38 8.38 2.12-2.12L20.12 18z"></path>
                </svg>
              </button> */}
                        </div>
                        <div>
                            <span className="text-white">
                                {this.props.t('sessionExpireWarning')}
                            </span>
                        </div>
                        <div className="flex flex-row items-center justify-end gap-4 mt-6">
                            <button
                                className="w-full py-2 text-base font-semibold text-white rounded-lg bg-UIprimary sm:w-3/12"
                                onClick={() => {
                                    this.setState({
                                        endVideoCallBufferAlert:
                                            !this.state.endVideoCallBufferAlert,
                                    });
                                }}
                            >
                                {this.props.t('ok')}
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    };

    // endVideoCallBufferFinalAlertModal
    endVideoCallBufferFinalAlertModal = () => {
        return (
            <Modal
                isOpen={this.state.endVideoCallFinalBufferAlert}
                overlayClassName={'modal-background z-index-1'}
                className={'modal-width-endcall'}
                ariaHideApp={false}
            >
                <div className="relative w-full max-w-2xl max-h-full">
                    <div className="relative p-6 rounded-lg shadow bg-card">
                        <div className="flex items-center justify-between mb-6">
                            <h5 className="text-lg font-medium text-white">
                                {this.props.t('endVisit')} {this.props.t('visit')}
                            </h5>
                        </div>
                        <div>
                            <span className="text-white">{this.props.t('sessionExpired')}</span>
                        </div>
                        <div className="flex flex-row items-center justify-end gap-4 mt-6">
                            <button
                                className="w-full py-2 text-base font-semibold text-white rounded-lg bg-UIprimary sm:w-3/12"
                                onClick={() => {
                                    this.endCallWebserviceWithBuffer(this.state.videoCallVisitId);
                                }}
                            >
                                Ok
                            </button>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    };

    // removeStudentAlertModal
    removeStudentAlertModal = () => {
        return (
            <Modal
                isOpen={this.state.removeStudentAlert}
                overlayClassName={'modal-background z-index-1'}
                className={'modal-width-endcall'}
                ariaHideApp={false}
            >
                <div className="relative w-full max-w-2xl max-h-full">
                    <div className="relative p-6 rounded-lg shadow bg-card">
                        <div className="flex items-center justify-between mb-6">
                            <h5 className="text-lg font-medium text-white">Removal Alert!</h5>
                        </div>
                        <div>
                            <span className="text-base text-white">
                                You are removed by owner from this session
                            </span>
                        </div>
                    </div>
                </div>
            </Modal>
        );
    };

    // onOpenSoap
    onOpenSoap = () => {
        this.setState({
            showSoap: !this.state.showSoap,
        });
    };

    // onScreenShotClicked
    onScreenShotClicked = () => {
        this.setState({ showBoard: !this.state.showBoard }, () => {
            this.ScreenShotEditModal.handleOpenDialog(this.state.showBoard);
        });
    };

    // onWhiteBoardClicked
    onWhiteBoardClicked = () => {
        this.setState({ whiteBoard: !this.state.whiteBoard }, () => {
            this.ScreenShotEditModal.hide(false);
        });
    };

    //onToggleBackgroundBlur
    onToggleBackgroundBlur = (enable, callback) => {
        if (!this.OpenTok) {
            callback(false);
            return;
        }
        this.OpenTok.onToggleBackgroundBlur(enable, (response) => {
            if (!response) {
                this.props.showNotification(this.props.t('backgroundBlurFailed'), 'error');
            }
            callback(response);
        });
    };

    //onMutePublisherVideo
    onMutePublisherVideo = (muteVideo, callBackmuteVideo) => {
        this.setState({ isVideoButtonDisabled: true, mutePublisherVideoClicked: true }, () => {});
        this.OpenTok.onMuteVideo(muteVideo, (response) => {
            if (response) {
                callBackmuteVideo(callBackmuteVideo);
                setTimeout(() => {
                    this.setState({ isVideoButtonDisabled: false }, () => {});
                }, 100);
            } else {
                callBackmuteVideo(response);
                this.props.showNotification(
                    this.props.t('connectionIsGettingEstablished'),
                    'error'
                );
                setTimeout(() => {
                    this.setState({ isVideoButtonDisabled: false }, () => {});
                }, 100);
            }
        });
    };

    // onMutePublisherVoice
    onMutePublisherVoice = (muteVoice, callBackMuteVoice) => {
        this.setState({ isAudioButtonDisabled: true, mutePublisherVoiceClicked: true }, () => {});
        if (this.state.isBroadCast && this.props.match.params.userType !== LevelTwoAdmin) {
            this.educatorMuteMessage(!muteVoice);
        }
        this.OpenTok.onMuteVoice(muteVoice, (response) => {
            if (response) {
                callBackMuteVoice(callBackMuteVoice);
                setTimeout(() => {
                    this.setState({ isAudioButtonDisabled: false }, () => {});
                }, 100);
            } else {
                callBackMuteVoice(response);
                this.props.showNotification(
                    this.props.t('connectionIsGettingEstablished'),
                    'error'
                );
                setTimeout(() => {
                    this.setState({ isAudioButtonDisabled: false }, () => {});
                }, 100);
            }
        });
    };

    // educatorMuteMessage
    educatorMuteMessage = (isMute, callBack) => {
        const { visitId } = this.props.match.params;
        let values = {
            visitId,
            isMute: isMute,
        };
        this.props.educatorMuteMessage(values, (response) => {
            if (response) {
                callBack(response);
            }
        });
    };

    //muteStudentAudio
    muteStudentAudio = (streamId) => {
        this.OpenTok.muteStudentAudio(streamId);
    };

    //muteStudentVideo
    muteStudentVideo = (streamId) => {
        this.OpenTok.muteStudentVideo(streamId);
    };

    //removeStudentStream
    removeStudentStream = (streamId, studentId, callBack) => {
        const { visitId } = this.props.match.params;
        let values = {
            visitId,
            studentId,
        };
        this.props.classRoomStudentRemove(values, (callback) => {
            if (callback) {
                this.OpenTok.removeStudentStream(streamId, (response) => {
                    callBack(response);
                });
            }
        });
    };

    //onRaiseHandPublisher
    onRaiseHandPublisher = (raiseHand, callBackRaiseHand) => {
        this.OpenTok.onRaiseHand(raiseHand, (response) => {
            if (response) {
                callBackRaiseHand(callBackRaiseHand);
            } else {
                callBackRaiseHand(response);
                this.props.showNotification(this.props.t('raiseNotReceived'), 'error');
            }
        });
    };

    //onBroadCastPublisher
    onBroadCastPublisher = () => {
        setTimeout(() => {
            if (
                this.state.isBroadCast &&
                !this.state.isBroadCastEnable &&
                !this.state.isInitialCallLoader
            ) {
                const { visitId } = this.props.match.params;
                this.props.startBroadCast(visitId, (response) => {
                    if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                        this.props.showNotification(
                            this.props.t('broadcastStartedSuccessfully'),
                            RESPONSE_CONSTANT.SUCCESS
                        );
                    } else if (response.code === RESPONSE_CONSTANT.EXISTING_NAME_CODE) {
                        this.props.showNotification(response.message, RESPONSE_CONSTANT.ERROR);
                    } else {
                        this.props.showNotification(this.props.t('broadcastNotStarted'), 'error');
                    }
                });
            }
        }, 5000);
    };

    // onSaveScreenShot
    onSaveScreenShot = (photo) => {
        const { visitId } = this.props.match.params;
        this.props.saveSnapShot(visitId, photo, (callback) => {
            if (callback) {
                this.props.showNotification(this.props.t('screenshotSavedSuccessfully'), 'success');
                this.getVisitEncounter(visitId);
                this.ScreenShotEditModal.handleCloseDialog();
            }
        });
    };

    handleWhiteboardToggle = () => {
        this.setState((prevState) => ({
            showWhiteboard: !prevState.showWhiteboard,
        }));
    };
    //cancelScreenshare
    cancelScreenshare = (value) => {
        this.setState({ cancelShare: value });
    };

    /**
     *
     * @param {*} videoCallDetails
     */
    _renderOpenTok(videoCallDetails) {
        const { sessionId, token, moderatorToken, apiKey, sessionTime, AnonymousRole } =
            this.state.urlParams || {};
        if (
            this.state.showEarlyJoinModal ||
            this.state.showAnonymousModal ||
            this.state.visitNotJoinable ||
            this.state.awaitingVisitStatus
        ) {
            console.log('OpenTok (One to One Session) not rendered - early/anonymous modal active', {
                showEarlyJoinModal: this.state.showEarlyJoinModal,
                showAnonymousModal: this.state.showAnonymousModal,
                visitNotJoinable: this.state.visitNotJoinable,
                awaitingVisitStatus: this.state.awaitingVisitStatus,
                isInitialCallLoader: this.state.isInitialCallLoader,
            });
            return null;
        }
        const hasUrlParams =
            apiKey && sessionId && token && moderatorToken && sessionTime && AnonymousRole;

        // Provide default values for videoCallDetails.activeSession
        const defaultActiveSession = {
            apikey: videoCallDetails.apikey,
            opentokSession: videoCallDetails.opentokSession,
            opentokToken: videoCallDetails.opentokToken,
            moderatorToken: videoCallDetails.moderatorToken,
            sessionTime: videoCallDetails.sessionTime,
        };

        const activeSession = videoCallDetails?.activeSession || defaultActiveSession;

        // Determine which parameters to use based on the availability of URL parameters and video call details
        const openTokParams = {
            apikey: hasUrlParams ? apiKey : activeSession.apikey,
            opentokSession: hasUrlParams ? sessionId : activeSession.opentokSession,
            opentokToken: hasUrlParams ? token : activeSession.opentokToken,
            moderatorToken: hasUrlParams ? moderatorToken : activeSession.moderatorToken,
            sessionTime: hasUrlParams ? sessionTime : activeSession.sessionTime,
        };

        const userType = this.props.match.params.userType;
        const sessionType = sessionStorage.getItem('SESSION_TYPE');
        const isInPersonSession = sessionType === 'IN_PERSON';
        const tokenToUse = isInPersonSession
            ? openTokParams.opentokToken
            : userType === Tutor
              ? openTokParams.moderatorToken || openTokParams.opentokToken
              : openTokParams.opentokToken;

        // ✅ PRIORITY 1: Check if PRIMARY/PROD credentials exist
        if (openTokParams.apikey && openTokParams.opentokSession && tokenToUse) {
            console.log(`🟢 [PRIORITY 1] One-to-One Session - PRIMARY (${hasUrlParams ? 'URL params' : 'Redux props'})`);
            
            return (
                <OpenTok
                    ref={(ref) => (this.OpenTok = ref)}
                    apiKey={openTokParams.apikey}
                    role={
                        this.props.match.params.userType === Tutor
                            ? Doctor
                            : this.props.match.params.userType === Student
                              ? Patient
                              : ''
                    }
                    sessionHelper={this.sessionHelper}
                    sessionId={openTokParams.opentokSession}
                    token={tokenToUse}
                    isMute={this.props.isMute}
                    callpatientUserId={this.props.userIds.patientUserId}
                    calldoctorUserId={this.props.userIds.doctorUserId}
                    profileImage={videoCallDetails.profileImage}
                    onCallbackStreams={(streams) => {
                        if (Array.isArray(streams)) {
                            this.setState({ isStreamsAvailable: streams.length > 0, streams });
                        }
                    }}
                    isInitialCallLoader={() => {
                        console.log('ActiveVisit: isInitialCallLoader callback (One to One Session) invoked', {
                            before: this.state.isInitialCallLoader,
                        });
                        this.setState({ isInitialCallLoader: false }, () => {
                            console.log('ActiveVisit: loader state updated (One to One Session)', {
                                after: this.state.isInitialCallLoader,
                            });
                        });
                    }}
                    showMessagePop={this.state.showMessagePop}
                    showParticipants={this.state.showParticipants}
                    fullScreenEnabled={this.state.fullScreen}
                    messageClicked={this.state.messageClicked}
                    minWidth={this.state.minWidth}
                    cancelScreenshare={this.cancelScreenshare}
                    renderLogoWithWifi={this.renderLogoWithWifi}
                    navigateToSummary={() => {
                        this.setState({ removeStudentAlert: true });
                        this.timer = setTimeout(() => {
                            this.setState({ removeStudentAlert: false });
                            this.props.history.push(
                                `${PATH.IM_PATIENT.WAITINGROOM}/${this.props.match.params.userId}/${this.props.match.params.visitId}`
                            );
                        }, 5000);
                    }}
                    userType={this.props.match.params.userType}
                    showWhiteboard={this.state.showWhiteboard}
                    visitId={this.props.match.params.visitId}
                    isWhiteboardOpen={this.props.isWhiteboardOpen}
                    videoCallDetails={this.props.videoCallDetails}
                    hasUrlParams={AnonymousRole}
                    sessionTypeParams={this.state.isOnetoOne}
                />
            );
        }

        // ❌ PRIMARY CREDENTIALS FAILED - Try PRIORITY 2: Socket credentials
        const vonageSocketCredentials = this.props.vonage_session_details || videoCallDetails?.vonage_session_details;
        if (vonageSocketCredentials?.apiKey && vonageSocketCredentials?.sessionId && vonageSocketCredentials?.token) {
            console.log('🟡 [PRIORITY 2] One-to-One Session - SOCKET credentials');
            const socketTokenToUse = isInPersonSession
                ? vonageSocketCredentials.token
                : userType === Tutor
                  ? vonageSocketCredentials.moderatorToken || vonageSocketCredentials.token
                  : vonageSocketCredentials.token;

            return (
                <OpenTok
                    ref={(ref) => (this.OpenTok = ref)}
                    apiKey={vonageSocketCredentials.apiKey}
                    role={userType === Tutor ? Doctor : userType === Student ? Patient : ''}
                    sessionHelper={this.sessionHelper}
                    sessionId={vonageSocketCredentials.sessionId}
                    token={socketTokenToUse}
                    isMute={this.props.isMute}
                    callpatientUserId={this.props.userIds.patientUserId}
                    calldoctorUserId={this.props.userIds.doctorUserId}
                    profileImage={videoCallDetails.profileImage}
                    onCallbackStreams={(streams) => {
                        if (Array.isArray(streams)) {
                            this.setState({ isStreamsAvailable: streams.length > 0, streams });
                        }
                    }}
                    isInitialCallLoader={() => {
                        this.setState({ isInitialCallLoader: false });
                    }}
                    showMessagePop={this.state.showMessagePop}
                    showParticipants={this.state.showParticipants}
                    fullScreenEnabled={this.state.fullScreen}
                    messageClicked={this.state.messageClicked}
                    minWidth={this.state.minWidth}
                    cancelScreenshare={this.cancelScreenshare}
                    renderLogoWithWifi={this.renderLogoWithWifi}
                    navigateToSummary={() => {
                        this.setState({ removeStudentAlert: true });
                        this.timer = setTimeout(() => {
                            this.setState({ removeStudentAlert: false });
                            this.props.history.push(
                                `${PATH.IM_PATIENT.WAITINGROOM}/${this.props.match.params.userId}/${this.props.match.params.visitId}`
                            );
                        }, 5000);
                    }}
                    userType={this.props.match.params.userType}
                    showWhiteboard={this.state.showWhiteboard}
                    visitId={this.props.match.params.visitId}
                    isWhiteboardOpen={this.props.isWhiteboardOpen}
                    videoCallDetails={this.props.videoCallDetails}
                    hasUrlParams={AnonymousRole}
                    sessionTypeParams={this.state.isOnetoOne}
                />
            );
        }

        // ❌ SOCKET CREDENTIALS ALSO FAILED - Try PRIORITY 3: API credentials
        const vonageApiCredentials = this.props.vonage_api_credentials || videoCallDetails?.vonage_api_credentials;
        if (vonageApiCredentials?.apiKey && vonageApiCredentials?.sessionId && vonageApiCredentials?.token) {
            console.log('🔵 [PRIORITY 3] One-to-One Session - API FALLBACK credentials');
            const apiTokenToUse = isInPersonSession
                ? vonageApiCredentials.token
                : userType === Tutor
                  ? vonageApiCredentials.moderatorToken || vonageApiCredentials.token
                  : vonageApiCredentials.token;

            return (
                <OpenTok
                    ref={(ref) => (this.OpenTok = ref)}
                    apiKey={vonageApiCredentials.apiKey}
                    role={userType === Tutor ? Doctor : userType === Student ? Patient : ''}
                    sessionHelper={this.sessionHelper}
                    sessionId={vonageApiCredentials.sessionId}
                    token={apiTokenToUse}
                    isMute={this.props.isMute}
                    callpatientUserId={this.props.userIds.patientUserId}
                    calldoctorUserId={this.props.userIds.doctorUserId}
                    profileImage={videoCallDetails.profileImage}
                    onCallbackStreams={(streams) => {
                        if (Array.isArray(streams)) {
                            this.setState({ isStreamsAvailable: streams.length > 0, streams });
                        }
                    }}
                    isInitialCallLoader={() => {
                        this.setState({ isInitialCallLoader: false });
                    }}
                    showMessagePop={this.state.showMessagePop}
                    showParticipants={this.state.showParticipants}
                    fullScreenEnabled={this.state.fullScreen}
                    messageClicked={this.state.messageClicked}
                    minWidth={this.state.minWidth}
                    cancelScreenshare={this.cancelScreenshare}
                    renderLogoWithWifi={this.renderLogoWithWifi}
                    navigateToSummary={() => {
                        this.setState({ removeStudentAlert: true });
                        this.timer = setTimeout(() => {
                            this.setState({ removeStudentAlert: false });
                            this.props.history.push(
                                `${PATH.IM_PATIENT.WAITINGROOM}/${this.props.match.params.userId}/${this.props.match.params.visitId}`
                            );
                        }, 5000);
                    }}
                    userType={this.props.match.params.userType}
                    showWhiteboard={this.state.showWhiteboard}
                    visitId={this.props.match.params.visitId}
                    isWhiteboardOpen={this.props.isWhiteboardOpen}
                    videoCallDetails={this.props.videoCallDetails}
                    hasUrlParams={AnonymousRole}
                    sessionTypeParams={this.state.isOnetoOne}
                />
            );
        }

        // ❌ NO CREDENTIALS AVAILABLE - Trigger API fallback after 3 seconds
        this.triggerSessionFallbackIfNeeded(this.getEffectiveVisitId(), 'OneToOne');
        console.log('[Session Join][OneToOne] ❌ No credentials available, waiting for fallback...');
        return null;
    }

    //  _renderOpenTokMultiUser(videoCallDetails) {
    //     const createdByID = this.props.studentDetails.createdBy;
    //     if (
    //         _.has(videoCallDetails?.activeSession, 'apikey') &&
    //         _.has(videoCallDetails?.activeSession, 'opentokSession') &&
    //         _.has(videoCallDetails?.activeSession, 'opentokToken')
    //     ) {
    //         return (
    //             <OpenTok
    //                 videoCallDetails={videoCallDetails}
    //                 studentDetails={this.props.studentDetails}
    //                 ref={(ref) => (this.OpenTok = ref)}
    //                 apiKey={videoCallDetails?.activeSession?.apikey}
    //                 role={
    //                     this.props.match.params.userType === Tutor
    //                         ? Doctor
    //                         : this.props.match.params.userType === Student
    //                           ? Patient
    //                           : this.props.match.params.userType === LevelTwoAdmin
    //                             ? LevelTwoAdmin
    //                             : ''
    //                 }
    //                 sessionId={videoCallDetails?.activeSession?.opentokSession}
    //                 token={
    //                     this.props.match.params.userType === Tutor
    //                         ? videoCallDetails?.activeSession?.moderatorToken
    //                         : videoCallDetails?.activeSession?.opentokToken
    //                 }
    //                 isMute={this.props.isMute}
    //                 profileImage={videoCallDetails.profileImage}
    //                 onCallbackStreams={(streams) => {
    //                     if (streams && streams.length) {
    //                         this.setState({ isStreamsAvailable: true, streams });
    //                     }
    //                 }}
    //                 isInitialCallLoader={() => {
    //                     this.setState({ isInitialCallLoader: false }, () => {
    //                         this.onBroadCastPublisher();
    //                     });
    //                 }}
    //                 showMessagePop={this.state.showMessagePop}
    //                 showParticipants={this.state.showParticipants}
    //                 fullScreenEnabled={this.state.fullScreen}
    //                 messageClicked={this.state.messageClicked}
    //                 minWidth={this.state.minWidth}
    //                 cancelScreenshare={this.cancelScreenshare}
    //                 muteForceStudent={(value) => {
    //                     this.setState({ muteAudioSingleStudent: value });
    //                 }}
    //                 muteVideoStudent={(value) => {
    //                     this.setState({ muteVideoSingleStudent: value });
    //                 }}
    //                 renderLogoWithWifi={this.renderLogoWithWifi}
    //                 navigateToSummary={() => {
    //                     this.setState({ removeStudentAlert: true });
    //                     this.timer = setTimeout(() => {
    //                         this.setState({ removeStudentAlert: false }, () => {
    //                             if (
    //                                 !this.state.mutePublisherVideoClicked &&
    //                                 !this.state.mutePublisherVoiceClicked
    //                             ) {
    //                                 this.props.history.push(
    //                                     `${PATH.IM_PATIENT.WAITINGROOM}/${this.props.match.params.userId}/${this.props.match.params.visitId}`
    //                                 );
    //                             }
    //                         });
    //                     }, 5000);
    //                 }}
    //                 userType={this.props.match.params.userType}
    //                 isWhiteboardOpen={this.props.isWhiteboardOpen}
    //                 OwnerAsCollaborator={createdByID}
    //             />
    //         );
    //     }
    // }

    /**
     *
     * @param {*} videoCallDetails
     */
    _renderOpenTokMultiUser(videoCallDetails) {
        const createdByID = this.props.studentDetails.createdBy;

        const { sessionId, token, moderatorToken, apiKey, sessionTime, AnonymousRole } =
            this.state.urlParams || {};
        if (
            this.state.showEarlyJoinModal ||
            this.state.showAnonymousModal ||
            this.state.visitNotJoinable ||
            this.state.awaitingVisitStatus
        ) {
            console.log('OpenTok (Group Session) not rendered - early/anonymous modal active', {
                showEarlyJoinModal: this.state.showEarlyJoinModal,
                showAnonymousModal: this.state.showAnonymousModal,
                visitNotJoinable: this.state.visitNotJoinable,
                awaitingVisitStatus: this.state.awaitingVisitStatus,
                isInitialCallLoader: this.state.isInitialCallLoader,
            });
            return null;
        }
        const hasUrlParams =
            apiKey && sessionId && token && moderatorToken && sessionTime && AnonymousRole;

        // Provide default values for videoCallDetails.activeSession
        const defaultActiveSession = {
            apikey: videoCallDetails.apikey,
            opentokSession: videoCallDetails.opentokSession,
            opentokToken: videoCallDetails.opentokToken,
            moderatorToken: videoCallDetails.moderatorToken,
            sessionTime: videoCallDetails.sessionTime,
        };

        const activeSession = videoCallDetails?.activeSession || defaultActiveSession;

        // Determine which parameters to use based on the availability of URL parameters and video call details
        const openTokParams = {
            apikey: hasUrlParams ? apiKey : activeSession.apikey,
            opentokSession: hasUrlParams ? sessionId : activeSession.opentokSession,
            opentokToken: hasUrlParams ? token : activeSession.opentokToken,
            moderatorToken: hasUrlParams ? moderatorToken : activeSession.moderatorToken,
            sessionTime: hasUrlParams ? sessionTime : activeSession.sessionTime,
        };

        // Check if we have the necessary parameters to render OpenTok

        // ✅ PRIORITY 1: Check if PRIMARY/PROD credentials exist
        if (openTokParams.apikey && openTokParams.opentokSession && openTokParams.opentokToken) {
            console.log(`🟢 [PRIORITY 1] Group/Conference Session - PRIMARY (${hasUrlParams ? 'URL params' : 'Redux props'})`);
            const userType = this.props.match.params.userType;
            const tokenToUse =
                userType === Tutor ? openTokParams.moderatorToken : openTokParams.opentokToken;

            return (
                <OpenTok
                    videoCallDetails={videoCallDetails}
                    studentDetails={{
                        ...this.props.studentDetails,
                        sessionUsers:
                            this.state.sessionUsers ||
                            this.props.studentDetails?.sessionUsers,
                        externalUsersDetails:
                            this.state.externalUsersDetails ||
                            this.props.studentDetails?.externalUsersDetails,
                    }}
                    ref={(ref) => (this.OpenTok = ref)}
                    apiKey={openTokParams.apikey}
                    role={
                        userType === Tutor
                            ? Doctor
                            : userType === Student
                              ? Patient
                              : userType === LevelTwoAdmin
                                ? LevelTwoAdmin
                                : ''
                    }
                    sessionId={openTokParams.opentokSession}
                    token={tokenToUse}
                    userId={hasUrlParams ? this.state.urlParams?.AnonymousUserId : this.props.match.params.userId}
                    isMute={this.props.isMute}
                    profileImage={videoCallDetails.profileImage}
                    onCallbackStreams={(streams) => {
                        if (Array.isArray(streams)) {
                            this.setState({ isStreamsAvailable: streams.length > 0, streams });
                        }
                    }}
                    isInitialCallLoader={() => {
                        console.log('ActiveVisit: isInitialCallLoader callback (Group Session) invoked', {
                            before: this.state.isInitialCallLoader,
                        });
                        this.setState({ isInitialCallLoader: false }, () => {
                            console.log('ActiveVisit: loader state updated (Group Session)', {
                                after: this.state.isInitialCallLoader,
                            });
                            this.onBroadCastPublisher();
                        });
                    }}
                    showMessagePop={this.state.showMessagePop}
                    showParticipants={this.state.showParticipants}
                    fullScreenEnabled={this.state.fullScreen}
                    messageClicked={this.state.messageClicked}
                    minWidth={this.state.minWidth}
                    cancelScreenshare={this.cancelScreenshare}
                    muteForceStudent={(value) => {
                        this.setState({ muteAudioSingleStudent: value });
                    }}
                    muteVideoStudent={(value) => {
                        this.setState({ muteVideoSingleStudent: value });
                    }}
                    renderLogoWithWifi={this.renderLogoWithWifi}
                    navigateToSummary={() => {
                        this.setState({ removeStudentAlert: true });
                        this.timer = setTimeout(() => {
                            this.setState({ removeStudentAlert: false }, () => {
                                if (
                                    !this.state.mutePublisherVideoClicked &&
                                    !this.state.mutePublisherVoiceClicked
                                ) {
                                    this.props.history.push(
                                        `${PATH.IM_PATIENT.WAITINGROOM}/${this.props.match.params.userId}/${this.props.match.params.visitId}`
                                    );
                                }
                            });
                        }, 5000);
                    }}
                    userType={userType}
                    isWhiteboardOpen={this.props.isWhiteboardOpen}
                    OwnerAsCollaborator={createdByID}
                    hasUrlParams={AnonymousRole}
                    sessionTypeParamsGroup={this.state.isGroupSession}
                    urlParams={this.state.urlParams}
                />
            );
        }

        // ❌ PRIMARY CREDENTIALS FAILED - Try PRIORITY 2: Socket credentials
        const vonageSocketCredentials = this.props.vonage_session_details || videoCallDetails?.vonage_session_details;
        if (vonageSocketCredentials?.apiKey && vonageSocketCredentials?.sessionId && vonageSocketCredentials?.token) {
            console.log('🟡 [PRIORITY 2] Group/Conference Session - SOCKET credentials');
            const userType = this.props.match.params.userType;
            const socketTokenToUse =
                userType === Tutor ? vonageSocketCredentials.moderatorToken : vonageSocketCredentials.token;

            return (
                <OpenTok
                    videoCallDetails={videoCallDetails}
                    studentDetails={{
                        ...this.props.studentDetails,
                        sessionUsers:
                            this.state.sessionUsers ||
                            this.props.studentDetails?.sessionUsers,
                        externalUsersDetails:
                            this.state.externalUsersDetails ||
                            this.props.studentDetails?.externalUsersDetails,
                    }}
                    ref={(ref) => (this.OpenTok = ref)}
                    apiKey={vonageSocketCredentials.apiKey}
                    role={
                        userType === Tutor
                            ? Doctor
                            : userType === Student
                              ? Patient
                              : userType === LevelTwoAdmin
                                ? LevelTwoAdmin
                                : ''
                    }
                    sessionId={vonageSocketCredentials.sessionId}
                    token={socketTokenToUse}
                    userId={hasUrlParams ? this.state.urlParams?.AnonymousUserId : this.props.match.params.userId}
                    isMute={this.props.isMute}
                    profileImage={videoCallDetails.profileImage}
                    onCallbackStreams={(streams) => {
                        if (Array.isArray(streams)) {
                            this.setState({ isStreamsAvailable: streams.length > 0, streams });
                        }
                    }}
                    isInitialCallLoader={() => {
                        this.setState({ isInitialCallLoader: false }, () => {
                            this.onBroadCastPublisher();
                        });
                    }}
                    showMessagePop={this.state.showMessagePop}
                    showParticipants={this.state.showParticipants}
                    fullScreenEnabled={this.state.fullScreen}
                    messageClicked={this.state.messageClicked}
                    minWidth={this.state.minWidth}
                    cancelScreenshare={this.cancelScreenshare}
                    muteForceStudent={(value) => {
                        this.setState({ muteAudioSingleStudent: value });
                    }}
                    muteVideoStudent={(value) => {
                        this.setState({ muteVideoSingleStudent: value });
                    }}
                    renderLogoWithWifi={this.renderLogoWithWifi}
                    navigateToSummary={() => {
                        this.setState({ removeStudentAlert: true });
                        this.timer = setTimeout(() => {
                            this.setState({ removeStudentAlert: false }, () => {
                                if (
                                    !this.state.mutePublisherVideoClicked &&
                                    !this.state.mutePublisherVoiceClicked
                                ) {
                                    this.props.history.push(
                                        `${PATH.IM_PATIENT.WAITINGROOM}/${this.props.match.params.userId}/${this.props.match.params.visitId}`
                                    );
                                }
                            });
                        }, 5000);
                    }}
                    userType={userType}
                    isWhiteboardOpen={this.props.isWhiteboardOpen}
                    OwnerAsCollaborator={createdByID}
                    hasUrlParams={AnonymousRole}
                    sessionTypeParamsGroup={this.state.isGroupSession}
                    urlParams={this.state.urlParams}
                />
            );
        }

        // ❌ SOCKET CREDENTIALS ALSO FAILED - Try PRIORITY 3: API credentials
        const vonageApiCredentials = this.props.vonage_api_credentials || videoCallDetails?.vonage_api_credentials;
        if (vonageApiCredentials?.apiKey && vonageApiCredentials?.sessionId && vonageApiCredentials?.token) {
            console.log('🔵 [PRIORITY 3] Group/Conference Session - API FALLBACK credentials');
            const userType = this.props.match.params.userType;
            const apiTokenToUse =
                userType === Tutor ? vonageApiCredentials.moderatorToken : vonageApiCredentials.token;

            return (
                <OpenTok
                    videoCallDetails={videoCallDetails}
                    studentDetails={{
                        ...this.props.studentDetails,
                        sessionUsers:
                            this.state.sessionUsers ||
                            this.props.studentDetails?.sessionUsers,
                        externalUsersDetails:
                            this.state.externalUsersDetails ||
                            this.props.studentDetails?.externalUsersDetails,
                    }}
                    ref={(ref) => (this.OpenTok = ref)}
                    apiKey={vonageApiCredentials.apiKey}
                    role={
                        userType === Tutor
                            ? Doctor
                            : userType === Student
                              ? Patient
                              : userType === LevelTwoAdmin
                                ? LevelTwoAdmin
                                : ''
                    }
                    sessionId={vonageApiCredentials.sessionId}
                    token={apiTokenToUse}
                    userId={hasUrlParams ? this.state.urlParams?.AnonymousUserId : this.props.match.params.userId}
                    isMute={this.props.isMute}
                    profileImage={videoCallDetails.profileImage}
                    onCallbackStreams={(streams) => {
                        if (Array.isArray(streams)) {
                            this.setState({ isStreamsAvailable: streams.length > 0, streams });
                        }
                    }}
                    isInitialCallLoader={() => {
                        this.setState({ isInitialCallLoader: false }, () => {
                            this.onBroadCastPublisher();
                        });
                    }}
                    showMessagePop={this.state.showMessagePop}
                    showParticipants={this.state.showParticipants}
                    fullScreenEnabled={this.state.fullScreen}
                    messageClicked={this.state.messageClicked}
                    minWidth={this.state.minWidth}
                    cancelScreenshare={this.cancelScreenshare}
                    muteForceStudent={(value) => {
                        this.setState({ muteAudioSingleStudent: value });
                    }}
                    muteVideoStudent={(value) => {
                        this.setState({ muteVideoSingleStudent: value });
                    }}
                    renderLogoWithWifi={this.renderLogoWithWifi}
                    navigateToSummary={() => {
                        this.setState({ removeStudentAlert: true });
                        this.timer = setTimeout(() => {
                            this.setState({ removeStudentAlert: false }, () => {
                                if (
                                    !this.state.mutePublisherVideoClicked &&
                                    !this.state.mutePublisherVoiceClicked
                                ) {
                                    this.props.history.push(
                                        `${PATH.IM_PATIENT.WAITINGROOM}/${this.props.match.params.userId}/${this.props.match.params.visitId}`
                                    );
                                }
                            });
                        }, 5000);
                    }}
                    userType={userType}
                    isWhiteboardOpen={this.props.isWhiteboardOpen}
                    OwnerAsCollaborator={createdByID}
                    hasUrlParams={AnonymousRole}
                    sessionTypeParamsGroup={this.state.isGroupSession}
                    urlParams={this.state.urlParams}
                />
            );
        }

        // ❌ NO CREDENTIALS AVAILABLE - Trigger API fallback after 3 seconds
        this.triggerSessionFallbackIfNeeded(this.getEffectiveVisitId(), 'GroupOrConference');
        console.log('[Session Join][GroupOrConference] ❌ No credentials available, waiting for fallback...');
        return null;
    }

    //_patientMessageClick
    _patientMessageClick = () => {
        this.setState({ messageClicked: !this.state.messageClicked });
        this.props.clearUnreadCount();
    };

    //onScreenShareClicked
    onScreenShareClicked = (shareScreen, callBackScreenShare) => {
        this.OpenTok.onscreenShare(shareScreen, (response) => {
            if (response) {
                callBackScreenShare(callBackScreenShare);
            }
        });
        this.setState({ screenShare: !this.state.screenShare });
    };

    //onFullScreenClicked
    onFullScreenClicked = (fullScreen, callBackmuteVideo) => {
        this.setState({ fullScreen: !this.state.fullScreen });
        this.props.clearUnreadCount();
    };

    /**
     * render the video button action view
     * @param {*} videoCallDetails
     * @param {*} isEndCallLoading
     * @param {*} chatCount
     * @param {*} isRecording
     * @param {*} match
     */
    _renderVideoOption(videoCallDetails, isEndCallLoading, chatCount, isRecording, match) {
        const {
            isAllowAudioVideoChatBtn,
            isAllowEndVisitBtn,
            isShowChatBtn,
            isShowVideoConsultation,
            isVideoButtonDisabled,
            isAudioButtonDisabled,
        } = this.state;
        const { apiKey, sessionId, token, moderatorToken, sessionTime } = this.state.urlParams;
        const hasUrlParams = apiKey && sessionId && token;
        const hasVideoCallDetails = _.size(videoCallDetails) !== 0;
        const isChatOpen = this.state.showMessagePop || this.state.messageClicked;
        // Determine if any stream is a screen share
        const hasScreenShare =
            this.state.streams &&
            this.state.streams.some(
                (stream) => stream.videoType === 'screen' || stream.name === 'screen'
            );
        if (hasUrlParams || hasVideoCallDetails) {
            const openTokParams = {
                apikey: apiKey || videoCallDetails.apikey,
                opentokSession: sessionId || videoCallDetails.opentokSession,
                opentokToken: token || videoCallDetails.opentokToken,
                moderatorToken: moderatorToken || videoCallDetails.moderatorToken,
                sessionTime: sessionTime || videoCallDetails.sessionTime,
            };
            return (
                <VideoOption
                    ref={(ref) => (this.VideoOption = ref)}
                    apiKey={openTokParams.apikey}
                    sessionId={openTokParams.opentokSession}
                    openMessagePop={this.openMessagePop.bind(this)}
                    closeMessagePop={this.closeMessagePop.bind(this)}
                    toggleParticipantsPop={this.toggleParticipantsPop.bind(this)}
                    isPatient={this.props.match.params.userType === Student ? true : false}
                    isOwner={this.props.match.params.userType === Tutor ? true : false}
                    minWidth={this.state.minWidth}
                    isMobileView={isMobileView}
                    messageClicked={this.state.messageClicked}
                    minWidthHandle={() => {
                        this._patientMessageClick();
                    }}
                    isEndCallLoading={isEndCallLoading}
                    unreadCount={isChatOpen ? 0 : chatCount}
                    showMessagePop={this.state.showMessagePop}
                    isChatOpen={isChatOpen}
                    showParticipants={this.state.showParticipants}
                    onEndCall={() => {
                        this.endVideoCall();
                    }}
                    onLeaveSession={this.leaveAnonymousSession}
                    onFullScreen={(fullScreen, callback) => {
                        this.onFullScreenClicked(fullScreen, (callBackmuteVideo) => {
                            callback(callBackmuteVideo);
                        });
                    }}
                    hasRecording={videoCallDetails.hasRecording}
                    isRecording={isRecording}
                    onRecord={() => {
                        this.onRecordClicked();
                    }}
                    onScreenShot={() => {
                        this.onScreenShotClicked();
                    }}
                    onWhiteBoard={() => {
                        this.onWhiteBoardClicked();
                    }}
                    onhideWhiteBoard={this.state.hideWhiteBoard}
                    onMuteVideo={(muteVideo, callback) => {
                        this.onMutePublisherVideo(muteVideo, (callBackmuteVideo) => {
                            callback(callBackmuteVideo);
                        });
                    }}
                    onToggleBackgroundBlur={this.onToggleBackgroundBlur}
                    onMuteVoice={(muteVoice, callBack) => {
                        this.onMutePublisherVoice(muteVoice, (callBackMuteVoice) => {
                            callBack(callBackMuteVoice);
                        });
                    }}
                    onRaiseHand={(raiseHand, callBack) => {
                        this.onRaiseHandPublisher(raiseHand, (callBackRaiseHand) => {
                            callBack(callBackRaiseHand);
                        });
                    }}
                    onScreenShare={(shareScreen, callback) => {
                        this.onScreenShareClicked(shareScreen, (callBackScreenShare) => {
                            callback(callBackScreenShare);
                        });
                    }}
                    cancelScreenshare={this.state.cancelShare}
                    muteAudioSingleStudent={this.state.muteAudioSingleStudent}
                    muteVideoSingleStudent={this.state.muteVideoSingleStudent}
                    streamAvailableStatus={
                        this.state.isBroadCast ? true : this.state.isStreamsAvailable
                    }
                    isAllowAudioVideoChatBtn={this.state.urlParams || isAllowAudioVideoChatBtn}
                    isAllowEndVisitBtn={isAllowEndVisitBtn}
                    isShowChatBtn={isShowChatBtn}
                    isShowVideoConsultation={isShowVideoConsultation}
                    isClassRoom={this.state.isClassRoom}
                    isBroadCast={this.state.isBroadCast}
                    showNotification={this.props.showNotification}
                    userType={this.props.match.params.userType}
                    isVideoButtonDisabled={isVideoButtonDisabled}
                    isAudioButtonDisabled={isAudioButtonDisabled}
                    showTimer={this.state.showTimer}
                    physicianShowTimer={this.props.physicianShowTimer}
                    videoCallDetails={this.props.videoCallDetails}
                    studentDetails={this.props.studentDetails}
                    handleWhiteboardToggle={this.handleWhiteboardToggle}
                    showWhiteboard={this.state.showWhiteboard}
                    visitId={this.props.match.params.visitId}
                    hasUrlParamsAnonymousRole={this.state.urlParams.AnonymousRole}
                    sessionTypeParamsisOnetoOne={this.state.isOnetoOne}
                    sessionEndTimeParamisGroupSession={this.state.isGroupSession}
                    isConferenceCall={this.state.isConferenceCall}
                    hasScreenShare={hasScreenShare}
                />
            );
        }
    }

    //_renderScreenShotEdit
    _renderScreenShotEdit() {
        return (
            <ScreenShotEditModal
                ref={(ref) => (this.ScreenShotEditModal = ref)}
                onSave={(photo) => {
                    this.onSaveScreenShot(photo);
                }}
                onHandleHide={(show) => {
                    this.setState({ hideWhiteBoard: show });
                }}
                visitId={this.state.videoCallVisitId}
            />
        );
    }

    //renderEncounter
    renderEncounter() {
        const {
            videoCallDetails,
            match,
            receiverImage,
            senderImage,
            chatList,
            isChatLoading,
            isSendMessageLoading,
        } = this.props;
        const {
            isVisitEncounterInfoScreen,
            isShowVideoConsultation,
            activeTab,
            isClassRoom,
            isBroadCast,
            minWidth,
            isGroupSession,
            isConferenceCall
        } = this.state;
        const shouldShowParticipantsTab =
            isClassRoom ||
            isBroadCast ||
            isGroupSession ||
            isConferenceCall ||
            (this.props.participantsDetails?.activeStudents?.length || 0) > 1;
        // In fullscreen mode, hide the entire right-hand encounter/chat panel
        // for Tutor/Doctor/LevelTwoAdmin so only the main video is visible.
        if (this.state.fullScreen) {
            return null;
        }

        return (
            <>
                {isVisitEncounterInfoScreen &&
                (match.params.userType === Tutor ||
                    match.params.userType === Doctor ||
                    match.params.userType === LevelTwoAdmin) ? (
                    <>
                        <div
                            className={`flex flex-col ${this.state.fullScreen ? 'hidden' : ''} ${
                                !minWidth ? '' : 'overflow-y-auto'
                            } ${
                                minWidth &&
                                (this.state.showMessagePop || this.state.showParticipants)
                                    ? 'mobile-height scrollbar video-fields-area chatpop w-full'
                                    : !minWidth && this.state.showMessagePop
                                      ? `scrollbar video-fields-area chatpop ${
                                            match.params.userType === LevelTwoAdmin
                                                ? 'w-30-videocall'
                                                : 'w-35'
                                        }`
                                      : minWidth && !this.state.showMessagePop
                                        ? 'video-fields-area hidden'
                                        : `scrollbar video-fields-area overflow-y-auto ${
                                              match.params.userType === LevelTwoAdmin
                                                  ? 'w-20-videocall'
                                                  : 'w-35'
                                          }`
                            }`}
                        >
                            {(!isClassRoom || !isConferenceCall) && (
                                <PatientInformation
                                    studentDetails={this.props.studentDetails}
                                    videoCallDetails={videoCallDetails}
                                    receiverImage={receiverImage}
                                    senderImage={senderImage}
                                    visitId={this.props.match.params.visitId}
                                    streams={this.state.streams}
                                    invokeKidInfo={() => this.invokeKidInfo()}
                                    _renderAddress={() => this._renderAddress(videoCallDetails)}
                                />
                            )}
                            {(!minWidth && !this.state.showMessagePop) ||
                            (minWidth && this.state.showParticipants) ? (
                                <>
                                    {minWidth && (
                                        <span
                                            className="flex items-center justify-end p-4 pb-0 cursor-pointer"
                                            onClick={() => this.toggleParticipantsPop()}
                                        >
                                            <i className="fal fa-xmark fa-lg"></i>
                                        </span>
                                    )}
                                    <nav className="flex flex-row border-b bg-card">
                                        {shouldShowParticipantsTab && (
                                            <button
                                                id="participants"
                                                className={
                                                    activeTab === 'participants'
                                                        ? 'text-UIprimary font-medium text-lg py-4 px-3 block hover:text-UIprimary focus:outline-none border-b-2  w-full'
                                                        : 'text-UIsecondary text-lg font-normal py-4 px-3 block focus:outline-none w-full'
                                                }
                                                onClick={() =>
                                                    this.setState({ activeTab: 'participants' })
                                                }
                                            >
                                                {this.props.t('participants')}
                                            </button>
                                        )}
                                        {match.params.userType !== LevelTwoAdmin &&
                                            this.props.studentDetails?.tutor?.userId ===
                                                JSON.parse(sessionStorage.getItem('userSession'))
                                                    .id && (
                                                <button
                                                    id="session_notes"
                                                    style={{
                                                        pointerEvents:
                                                            !isClassRoom &&
                                                            !isBroadCast &&
                                                            !this.state.isGroupSession &&
                                                            !isConferenceCall &&
                                                            !shouldShowParticipantsTab &&
                                                            'none',
                                                    }}
                                                    className={
                                                        activeTab === 'sessionNotes'
                                                            ? `text-UIprimary font-medium text-lg py-4 px-3 block hover:text-UIprimary focus:outline-none border-b-2 ${
                                                                  shouldShowParticipantsTab &&
                                                                  'w-full'
                                                              } `
                                                            : `text-UIsecondary text-lg font-normal py-4 px-3 block focus:outline-none ${
                                                                  shouldShowParticipantsTab &&
                                                                  'w-full'
                                                              }`
                                                    }
                                                    onClick={() =>
                                                        this.setState({ activeTab: 'sessionNotes' })
                                                    }
                                                >
                                                    {this.props.t('sessionNotes')}
                                                </button>
                                            )}
                                    </nav>
                                </>
                            ) : (
                                ''
                            )}

                            {activeTab === 'participants' &&
                            (!this.state.showMessagePop || this.state.showParticipants) ? (
                                <div
                                    id="participants"
                                    className="h-full pr-1 overflow-y-auto grow bg-collaboratortable"
                                >
                                    <ParticipantContent
                                        studentDetails={this.props.studentDetails}
                                        sessionUsers={this.state.sessionUsers}
                                        streams={this.state.streams}
                                        session={this.OpenTok?.sessionHelper?.session}
                                        participantsDetails={this.props.participantsDetails}
                                        isBroadCast={this.state.isBroadCast}
                                        muteStudentAudio={(streamId) => {
                                            this.muteStudentAudio(streamId);
                                        }}
                                        muteStudentVideo={(streamId) => {
                                            this.muteStudentVideo(streamId);
                                        }}
                                        removeStudentStream={(
                                            streamId,
                                            studentName,
                                            studentId,
                                            callback
                                        ) => {
                                            this.removeStudentStream(
                                                streamId,
                                                studentId,
                                                (callBackResponse) => {
                                                    this.props.showNotification(
                                                        `${studentName} ${this.props.t('studentRemovedFromGroupSession')}`,
                                                        'success'
                                                    );
                                                    callback(callBackResponse);
                                                }
                                            );
                                        }}
                                        sessionTypeParams={this.state.isGroupSession}
                                    />
                                </div>
                            ) : null}
                            {this.state.showMessagePop ? (
                                <>
                                    {this.props.isSocketDownProblem ? (
                                        <SocketDownScreen />
                                    ) : (
                                        <>
                                            {match.params.userType !== LevelTwoAdmin ? (
                                                <Message
                                                    ref={(Message) => {
                                                        this._message = Message;
                                                    }}
                                                    closeMessagePop={this.closeMessagePop.bind(
                                                        this
                                                    )}
                                                    chatList={chatList}
                                                    isChatLoading={isChatLoading}
                                                    receiverImage={receiverImage}
                                                    senderImage={senderImage}
                                                    userType={Doctor}
                                                    patientName={videoCallDetails.patientName}
                                                    onSendMessage={(
                                                        textMessage,
                                                        chatImage,
                                                        havingImage,
                                                        receiverId
                                                    ) => {
                                                        myLog(
                                                            'onSendMessage',
                                                            textMessage,
                                                            chatImage,
                                                            havingImage,
                                                            receiverId
                                                        );
                                                        this.invokeonSendMessage(
                                                            textMessage,
                                                            chatImage,
                                                            havingImage,
                                                            receiverId
                                                        );
                                                    }}
                                                    streams={this.state.streams}
                                                    sessionUsers={this.state.sessionUsers}
                                                    isSendMessageLoading={isSendMessageLoading}
                                                    isClassRoom={isClassRoom}
                                                    callChatAPI={() => {
                                                        this.invokeChatList(
                                                            this.state.currentChatPage
                                                        );
                                                    }}
                                                    chatLastPage={this.state.chatLastPage}
                                                    currentChatPage={this.state.currentChatPage}
                                                    isConferenceCall={isConferenceCall}
                                                />
                                            ) : (
                                                <MessageLevelTwo
                                                    ref={(Message) => {
                                                        this._message = Message;
                                                    }}
                                                    closeMessagePop={this.closeMessagePop.bind(
                                                        this
                                                    )}
                                                    chatList={chatList}
                                                    isChatLoading={isChatLoading}
                                                    receiverImage={receiverImage}
                                                    senderImage={senderImage}
                                                    userType={Doctor}
                                                    patientName={videoCallDetails.patientName}
                                                    onSendMessage={(
                                                        textMessage,
                                                        chatImage,
                                                        havingImage,
                                                        receiverId
                                                    ) => {
                                                        myLog(
                                                            'onSendMessage',
                                                            textMessage,
                                                            chatImage,
                                                            havingImage,
                                                            receiverId
                                                        );
                                                        this.invokeonSendMessage(
                                                            textMessage,
                                                            chatImage,
                                                            havingImage,
                                                            receiverId
                                                        );
                                                    }}
                                                    streams={this.state.streams}
                                                    sessionUsers={this.state.sessionUsers}
                                                    isSendMessageLoading={isSendMessageLoading}
                                                    isClassRoom={isClassRoom}
                                                    callChatAPI={() => {
                                                        this.invokeChatList(
                                                            this.state.currentChatPage
                                                        );
                                                    }}
                                                    chatLastPage={this.state.chatLastPage}
                                                    currentChatPage={this.state.currentChatPage}
                                                />
                                            )}
                                        </>
                                    )}
                                </>
                            ) : null}
                            {!this.state.showMessagePop && activeTab === 'sessionNotes' && (
                                <Soap
                                    studentDetails={this.props.studentDetails}
                                    visitId={match.params.visitId}
                                    userId={match.params.userId}
                                    patientUserId={match.params.patientUserId}
                                    onUpdateSoap={(subjective, objective, assessment, plan) =>
                                        this.props.updateSoap(
                                            subjective,
                                            objective,
                                            plan,
                                            assessment
                                        )
                                    }
                                />
                            )}
                        </div>
                    </>
                ) : isShowVideoConsultation && !minWidth ? (
                    <>
                        <PhysicianMessage
                            ref={(Message) => {
                                this._message = Message;
                            }}
                            closeMessagePop={this.closeMessagePop.bind(this)}
                            chatList={this.props.chatList}
                            isChatLoading={this.props.isChatLoading}
                            receiverImage={this.props.receiverImage}
                            senderImage={this.props.senderImage}
                            userType={
                                this.props.match.params.userType === Tutor
                                    ? Doctor
                                    : this.props.match.params.userType
                            }
                            patientName={this.props.videoCallDetails.patientName}
                            onSendMessage={(textMessage, chatImage, havingImage, receiverId) => {
                                myLog(
                                    'onSendMessage',
                                    textMessage,
                                    chatImage,
                                    havingImage,
                                    receiverId
                                );
                                this.invokeonSendMessage(
                                    textMessage,
                                    chatImage,
                                    havingImage,
                                    receiverId
                                );
                            }}
                            isSendMessageLoading={this.props.isSendMessageLoading}
                            isClassRoom={isClassRoom}
                        />
                    </>
                ) : (
                    ''
                )}
            </>
        );
    }

    //handleChangeNetworkColor
    handleChangeNetworkColor = (speed) => {
        if (speed > 1000) {
            this.setState({ showColor: 'green' });
        } else if (speed <= 1000 && speed > 350) {
            this.setState({ showColor: 'orange' });
        } else {
            this.setState({ showColor: 'red' });
        }
    };

    //renderLogoWithWifi
    renderLogoWithWifi = () => {
        return (
            <>
                {this.state.minWidth &&
                (this.state.showMessagePop ||
                    this.state.showParticipants ||
                    this.state.messageClicked)
                    ? null
                    : isWhiteLabled && (
                          <>
                              {this.state.showColor === 'red' ? (
                                  <div className="weak-signal">
                                      <span
                                          style={{
                                              color: '#FFF',
                                          }}
                                      >
                                          <i className="fas fa-wifi"></i>
                                      </span>
                                      {this.state.showColor === 'red' ? (
                                          <span>
                                              Due to your low wi-fi bandwidth availability, our
                                              website may experience slower loading times and
                                              reduced functionality.
                                          </span>
                                      ) : null}
                                  </div>
                              ) : null}
                              <div
                                  className={`flex justify-between items-center m-4 ${
                                      this.state.isClassRoom ||
                                      this.state.isGroupSession ||
                                      this.state.urlParams.AnonymousRole || this.state.isConferenceCall
                                          ? 'pt-6'
                                          : ''
                                  }`}
                              >
                                  <div className="flex items-center justify-between video-logo">
                                      {/* <GetImage isVideoLogo={true} /> */}
                                  </div>
                                  {/* Show network bandwidth speed */}
                                  {this.state.showColor !== 'red' ? (
                                      <div className="high-signal">
                                          <span
                                              style={{
                                                  color:green[500],
                                              }}
                                          >
                                              <i className="fas fa-wifi"></i>
                                          </span>
                                      </div>
                                  ) : null}
                              </div>
                          </>
                      )}
            </>
        );
    };

    //handleEndBroadcastSession
    handleEndBroadcastSession = (error, data) => {
        const { userId, visitId } = this.props.match.params;
        if (
            error === 'hlsError' &&
            data &&
            data.type === 'networkError' &&
            data.details === 'levelLoadError'
        ) {
            this.props.endStudentBroadCastSession((res) => {
                if (res) {
                    this.props.showNotification(this.props.t('ownerEndedSession'), 'error');
                    this.props.history.push(`${PATH.IM_PATIENT.WAITINGROOM}/${userId}/${visitId}`);
                }
            });
        }
    };

    // Method to render the popup shown when the visit is already over
    renderSessionEndedScreen = () => {
        if (!this.state.visitNotJoinable) return null;

        return (
            <div
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: '#181B22',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 9999,
                }}
            >
                <div
                    className="bg-card"
                    style={{
                        padding: '20px',
                        borderRadius: '8px',
                        textAlign: 'center',
                        maxWidth: '400px',
                        boxShadow: '0 0 10px rgba(0,0,0,0.3)',
                    }}
                >
                    <h2 style={{ marginBottom: '10px', fontWeight: 'bold', color: 'white' }}>
                        {this.props.t('sessionEnded')}
                    </h2>
                    <p style={{ fontSize: '16px', color: 'white' }}>
                        {this.props.t('sessionHasEnded')}
                    </p>
                </div>
            </div>
        );
    };

    // Method to render the popup shown after a third party leaves the session
    renderLeftSessionScreen = () => {
        if (!this.state.hasLeftSession) return null;

        return (
            <div
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: '#181B22',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 9999,
                }}
            >
                <div
                    className="bg-card"
                    style={{
                        padding: '20px',
                        borderRadius: '8px',
                        textAlign: 'center',
                        maxWidth: '400px',
                        boxShadow: '0 0 10px rgba(0,0,0,0.3)',
                    }}
                >
                    <h2 style={{ marginBottom: '10px', fontWeight: 'bold', color: 'white' }}>
                        {this.props.t('youHaveLeftTheSession')}
                    </h2>
                    <p style={{ fontSize: '16px', color: 'white' }}>
                        {this.props.t('youMayCloseThisTab')}
                    </p>
                </div>
            </div>
        );
    };

    // Method to render the popup for Anonymous role
    renderAnonymousEndCallPopup = () => {
        const urlParams = new URLSearchParams(window.location.search);
        const AnonymousRole = urlParams.get('role');

        if (!this.props.showAnonymousEndCallPopup || AnonymousRole !== Anonymous) return null;

        return (
            <div
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    backgroundColor: 'rgba(0, 0, 0, 0.5)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 9999,
                }}
            >
                <div  className="bg-card"
                    style={{
                        // backgroundColor: 'white',
                        padding: '20px',
                        borderRadius: '8px',
                        textAlign: 'center',
                        maxWidth: '400px',
                        boxShadow: '0 0 10px rgba(0,0,0,0.3)',
                    }}
                >
                    <h2 style={{ marginBottom: '10px', fontWeight: 'bold', color:"white" }}>{this.props.t('sessionEnded')}</h2>
                    <p style={{ fontSize: '16px', color:"white" }}>{`${this.props.t('your')} ${AppConfig.isHealthCare
                                            ? this.props.t('doctor')
                                            : this.props.t('owner')} ${this.props.t('hasEndedTheSession')}`}.</p>
                    {/* <button
                        onClick={() => {
                            // Clear all anonymous user data from storage
                            store.remove('anonymousUser');
                            store.remove('AnonymousRole');
                            store.remove('userId');
                            store.remove('visitId');
                            store.remove('socketAuthentication');
                            store.remove('socketAuthenticationParams');
                            console.log('[Anonymous User] Cleared all anonymous storage and closing tab');
                            // Close the tab/window
                            window.close();
                            // If window.close() doesn't work (some browsers block it), redirect to a blank page
                            setTimeout(() => {
                                window.location.href = 'about:blank';
                            }, 100);
                        }}
                        style={{
                            marginTop: '20px',
                            padding: '10px 20px',
                            backgroundColor: '#007bff',
                            color: 'white',
                            border: 'none',
                            borderRadius: '4px',
                            cursor: 'pointer',
                        }}
                    >
                        {this.props.t('ok') || 'OK'}
                    </button> */}
                </div>
            </div>
        );
    };

    // Render Anonymous Modal
    renderAnonymousModal = () => {
        // Held back until the visit status check answers: asking for a name and
        // then replacing the form with "session ended" reads as a glitch.
        if (!this.state.showAnonymousModal || this.state.awaitingVisitStatus) return null;

        return (
            <div
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 9999,
                }}
            >
                <div
                    className="bg-card"
                    style={{
                        // backgroundColor: 'white',
                        padding: '30px',
                        borderRadius: '8px',
                        maxWidth: '500px',
                        width: '90%',
                        boxShadow: '0 0 15px rgba(0, 0, 0, 0.3)',
                        position: 'relative',
                    }}
                >
                    <div
                        style={{
                            marginBottom: '24px',
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <h5 style={{ fontSize: '1.25rem', fontWeight: '600', color: 'white' }}>
                            {this.props.t('enterYourDetails')}
                        </h5>
                    </div>

                    <form onSubmit={this.handleAnonymousSubmit}>
                        <div style={{ marginBottom: '16px' }}>
                            <label
                                htmlFor="firstName"
                                style={{
                                    display: 'block',
                                    marginBottom: '6px',
                                    fontWeight: 'normal',
                                    color: 'white',
                                }}
                            >
                                {this.props.t('firstName')} <span style={{ color: 'red' }}>*</span>
                            </label>
                            <input
                                id="firstName"
                                type="text"
                                placeholder={this.props.t('enterFirstName')}
                                value={this.state.firstName}
                                onChange={(e) => this.setState({ firstName: e.target.value })}
                                maxLength={50}
                                style={{
                                    width: '100%',
                                    padding: '8px 12px',
                                    borderRadius: '4px',
                                    // border: '1px solid #444',
                                    outline: 'none',
                                    backgroundColor: '#000', // 👈 black background
                                    color: '#fff', // 👈 text visible on black
                                }}
                                onFocus={(e) => (e.target.style.borderColor = '#3182ce')}
                                onBlur={(e) => (e.target.style.borderColor = '#ccc')}
                            />
                        </div>

                        <div style={{ marginBottom: '24px' }}>
                            <label
                                htmlFor="lastName"
                                style={{
                                    display: 'block',
                                    marginBottom: '6px',
                                    fontWeight: 'normal',
                                    color: 'white',
                                }}
                            >
                                {this.props.t('lastName')} <span style={{ color: 'red' }}>*</span>
                            </label>
                            <input
                                id="lastName"
                                type="text"
                                placeholder={this.props.t('enterLastName')}
                                value={this.state.lastName}
                                onChange={(e) => this.setState({ lastName: e.target.value })}
                                maxLength={50}
                                style={{
                                    width: '100%',
                                    padding: '8px 12px',
                                    borderRadius: '4px',
                                    // border: '1px solid #444',
                                    outline: 'none',
                                    backgroundColor: '#000', // 👈 black background
                                    color: '#fff', // 👈 text visible on black
                                }}
                                onFocus={(e) => (e.target.style.borderColor = '#3182ce')}
                                onBlur={(e) => (e.target.style.borderColor = '#ccc')}
                            />
                        </div>

                        <div
                            style={{ display: 'flex', justifyContent: 'flex-end' }}
                            >
                            <button
                                className="bg-UIprimary "
                                type="submit"
                                style={{
                                    // backgroundColor: 'rgba(40, 35, 92, 1)',
                                    color: '#fff',
                                    padding: '8px 16px',
                                    borderRadius: '6px',
                                    border: 'none',
                                    fontWeight: '600',
                                    cursor: 'pointer',
                                    minWidth: '100px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                }}
                                disabled={this.state.isLoading}
                            >
                                {this.state.isLoading ? <Spinner color="#FFF" /> : this.props.t('save')}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        );
    };

    // runVisitStatusGate
    // The visit decides on every entry, not only the first. A third party who
    // already gave their name skips the name form, so without this they would
    // walk straight back into a session that is over.
    runVisitStatusGate = (visitId) => {
        this.props.getVisitStatus(visitId, (statusResult) => {
            if (!this.canJoinFromVisitStatus(statusResult)) {
                this.setState(
                    {
                        awaitingVisitStatus: false,
                        showAnonymousModal: false,
                        showEarlyJoinModal: false,
                        visitNotJoinable: true,
                    },
                    () => {
                        this.closeTabTimer = setTimeout(() => {
                            this.closeSessionTab();
                        }, LEFT_SESSION_CLOSE_DELAY);
                    }
                );
                return;
            }
            this.setState({ awaitingVisitStatus: false });
        });
    };

    // canJoinFromVisitStatus
    // The endpoint answers with a plain boolean in `response`: true lets the
    // third party in, anything else keeps them out. A call that never returned
    // an answer at all counts as a refusal.
    canJoinFromVisitStatus = (statusResult) => {
        console.log('[Anonymous User] visit status response', statusResult);

        if (!statusResult || statusResult.code !== RESPONSE_CONSTANT.SUCCESS_CODE) {
            return false;
        }
        return statusResult.response === true;
    };

    // Handle Anonymous Submit
    handleAnonymousSubmit = (e) => {
        e.preventDefault();
        const { firstName, lastName, urlParams } = this.state;
        const trimmedFirstName = firstName.trim();
        const trimmedLastName = lastName.trim();

        if (!trimmedFirstName || !trimmedLastName) {
            this.props.showNotification(
                RESPONSE_CONSTANT.FIRSTNAME_LASTNAME_REQUIRED,
                RESPONSE_CONSTANT.WARNING
            );
            return;
        }

        const values = {
            firstName: trimmedFirstName,
            lastName: trimmedLastName,
            userId: urlParams.AnonymousUserId,
            visitId: urlParams.AnonymousVisitId,
        };

        this.setState({ isLoading: true });

        this.props.anonymousUserDetails(values, (response) => {
            if (response.code === RESPONSE_CONSTANT.SUCCESS_CODE) {
                const anonymousCredentials = this.resolveAnonymousCredentials(response);

                // CRITICAL FIX: Set BOTH sessionUsers AND externalUsersDetails
                this.setState({
                    sessionUsers: response.response?.sessionUsers || [],
                    externalUsersDetails: response.response?.externalUsersDetails || [],
                }, () => {
                    // After state is updated, emit stream ID if other users are present
                    // console.log('[Anonymous User] Initial data from API - State updated', {
                    //     sessionUsers: this.state.sessionUsers?.length || 0,
                    //     externalUsersDetails: this.state.externalUsersDetails?.length || 0,
                    //     externalUsers: this.state.externalUsersDetails,
                    // });
                    
                    // Trigger streamId emission after state update
                    if (this.OpenTok?.emitStreamId) {
                        setTimeout(() => {
                            this.OpenTok.emitStreamId();
                        }, 500);
                    }
                });
                
                this.props.showNotification(response.message, RESPONSE_CONSTANT.SUCCESS);
                
                // Connect to socket after saving details
                this.props.startChatSocketConnect(
                    anonymousCredentials.userId || urlParams.AnonymousUserId,
                    Anonymous,
                    urlParams.AnonymousVisitId,
                    this.props
                );
                
                store.set('anonymousUser', `${trimmedFirstName} ${trimmedLastName}`);

                // The details are saved, but the visit itself decides whether
                // this third party is let in.
                this.props.getVisitStatus(urlParams.AnonymousVisitId, (statusResult) => {
                    if (!this.canJoinFromVisitStatus(statusResult)) {
                        // The visit is over, so say so and close the tab the
                        // same way leaving the session does.
                        this.setState(
                            {
                                isLoading: false,
                                showAnonymousModal: false,
                                visitNotJoinable: true,
                            },
                            () => {
                                this.closeTabTimer = setTimeout(() => {
                                    this.closeSessionTab();
                                }, LEFT_SESSION_CLOSE_DELAY);
                            }
                        );
                        return;
                    }

                    this.setState({ isLoading: false, showAnonymousModal: false });

                    if (urlParams.sessionTypeParams === 'one-to-one') {
                        this._renderOpenTok(this.props.videoCallDetails);
                    } else {
                        this._renderOpenTokMultiUser(this.props.videoCallDetails);
                    }
                });
            } else {
                console.error('API call failed');
                this.props.showNotification(response.message, RESPONSE_CONSTANT.WARNING);
            }
        });
    };

    render() {
        const {
            videoCallDetails,
            match,
            isEndCallLoading,
            chatList,
            isChatLoading,
            receiverImage,
            senderImage,
            isSendMessageLoading,
            chatCount,
            isRecording,
            isOnline,
            isNetworkProblem,
            // studentDetails,
        } = this.props;
        const urlParams = new URLSearchParams(window.location.search);
        const AnonymousRole = urlParams.get('role');
        const { isVisitInfoWithUserInfoScreen, minWidth } = this.state;
        myLog('this.props', this.props);
        return (
            <div className={`${isOnline && !isNetworkProblem ? 'video-record' : 'hidden'}`}>
                {/* Sits outside the call container: that container is hidden
                    while the initial loader runs, and a refused visit never
                    gets far enough to turn the loader off. */}
                {this.renderSessionEndedScreen()}
                <VideoCallLoader
                    isInitialCallLoader={
                        this.state.visitNotJoinable
                            ? false
                            : this.state.isBroadCast && match.params.userType === Student
                              ? false
                              : this.state.isInitialCallLoader
                    }
                />
                <div
                    style={{
                        display:
                            this.state.isBroadCast && match.params.userType === Student
                                ? 'block'
                                : this.state.isInitialCallLoader
                                  ? 'none'
                                  : 'block',
                    }}
                >
                    {/* call */}
                    <div
                        className={`video-call ${
                            (this.state.showMessagePop ||
                                this.state.showParticipants ||
                                this.state.messageClicked) &&
                            this.state.isClassRoom &&
                            this.state.isGroupSession && this.state.isConferenceCall &&
                            this.state.minWidth
                                ? 'classroom-z-index'
                                : ''
                        }`}
                    >
                        {this.state.isBroadCast && (match.params.userType === Student || match.params.userType === Tutor) ? (
                            <>
                                <div
                                    className={`${
                                        minWidth || this.state.fullScreen
                                            ? 'video-area w-full'
                                            : 'video-area w-65'
                                    }`}
                                    style={{ background: 'black' }}
                                >
                                    <div className="broadcast-view broadcast">
                                        {this.props.isWhiteboardOpen ? (
                                            <>
                                                <ScreenShotEditModal
                                                    visitId={this.state.videoCallVisitId}
                                                />

                                                <ReactPlayer
                                                    className="react-player"
                                                    url={store.get('broadcastUrl')}
                                                    width="100%"
                                                    height="100%"
                                                    playing={true}
                                                    playsinline={true}
                                                    controls={true}
                                                    config={{
                                                        attributes: {
                                                            disablePictureInPicture: true,

                                                            controlsList: 'nodownload',
                                                        },
                                                    }}
                                                    onEnded={() => {
                                                        console.log('onEnded');

                                                        this.props.showNotification(
                                                            this.props.t('videoStreamIsLoading'),

                                                            'error'
                                                        );
                                                    }}
                                                    onError={(error, data) => {
                                                        console.log(error, 'onError', data);

                                                        this.handleEndBroadcastSession(error, data);
                                                    }}
                                                />
                                            </>
                                        ) : (
                                            <ReactPlayer
                                                className="react-player"
                                                url={store.get('broadcastUrl')}
                                                width="100%"
                                                height="100%"
                                                playing={true}
                                                playsinline={true}
                                                controls={true}
                                                config={{
                                                    attributes: {
                                                        disablePictureInPicture: true,

                                                        controlsList: 'nodownload',
                                                    },
                                                }}
                                                onEnded={() => {
                                                    console.log('onEnded');

                                                    this.props.showNotification(
                                                        this.props.t('videoStreamIsLoading'),

                                                        'error'
                                                    );
                                                }}
                                                onError={(error, data) => {
                                                    console.log(error, 'onError', data);

                                                    this.handleEndBroadcastSession(error, data);
                                                }}
                                            />
                                        )}
                                    </div>
                                    <div style={{ height: '10% !important' }}>
                                        {this.state.showSoap
                                            ? ''
                                            : this._renderVideoOption(
                                                  videoCallDetails,
                                                  isEndCallLoading,
                                                  chatCount,
                                                  isRecording,
                                                  match
                                              )}
                                    </div>
                                </div>
                            </>
                        ) : (
                            <div
                                className={
                                    minWidth
                                        ? 'video-area w-full'
                                        : this.state.fullScreen
                                          ? 'video-area w-full'
                                          : `video-area ${
                                                match.params.userType === LevelTwoAdmin
                                                    ? this.state.showMessagePop
                                                        ? 'w-70-videocall'
                                                        : 'w-80-videocall'
                                                    : 'w-65'
                                            }`
                                }
                            >
                                {/* Video section */}
                                {/* {AnonymousRole ? (
                                    <>
                                        {this._renderOpenTokMultiUser(videoCallDetails)}
                                        {this._renderOpenTok(videoCallDetails)}
                                    </>
                                ) : this.state.isClassRoom || this.state.isBroadCast ? (
                                    this._renderOpenTokMultiUser(videoCallDetails)
                                ) : (
                                    this._renderOpenTok(videoCallDetails)
                                )} */}
                                {this.state.isClassRoom ||
                                this.state.isBroadCast ||
                                this.state.isGroupSession || this.state.isConferenceCall
                                    ? this._renderOpenTokMultiUser(videoCallDetails)
                                    : this._renderOpenTok(videoCallDetails)}
                                {/* Video options */}
                                {this.state.showSoap
                                    ? ''
                                    : this._renderVideoOption(
                                          videoCallDetails,
                                          isEndCallLoading,
                                          chatCount,
                                          isRecording,
                                          match
                                      )}
                            </div>
                        )}
                        {/* Educator Session Notes/Participants */}
                        {this.renderEncounter()}
                        {/* Student Chat */}
                        {(match.params.userType === Student || store.get('AnonymousRole')) &&
                        !this.state.fullScreen ? (
                            <div
                                className={`${
                                    !this.state.minWidth ? 'flex flex-col' : 'overflow-y-auto'
                                } ${
                                    this.state.minWidth && this.state.messageClicked
                                        ? 'mobile-height scrollbar video-fields-area chatpop w-full'
                                        : !this.state.minWidth && this.state.messageClicked
                                          ? 'scrollbar video-fields-area chatpop w-35'
                                          : this.state.minWidth && !this.state.messageClicked
                                            ? 'video-fields-area hidden'
                                            : 'scrollbar video-fields-area overflow-y-auto w-35'
                                }`}
                            >
                                {/* Participant Tab Header for Group/Conference Sessions */}
                                {!this.state.messageClicked && (this.state.isGroupSession || this.state.isConferenceCall) && (
                                    <>
                                        <nav className="flex flex-row border-b bg-card">
                                            <button
                                                className="text-UIprimary font-medium text-lg py-4 px-3 block hover:text-UIprimary focus:outline-none border-b-2 w-full"
                                            >
                                                {this.props.t('participants')}
                                            </button>
                                        </nav>
                                        <div className="h-full pr-1 overflow-y-auto bg-collaboratortable" style={{ maxHeight: '40vh' }}>
                                            <ParticipantContent
                                                studentDetails={this.props.studentDetails}
                                                sessionUsers={this.state.sessionUsers}
                                                streams={this.state.streams}
                                                session={this.OpenTok?.sessionHelper?.session}
                                                participantsDetails={this.props.participantsDetails}
                                                isBroadCast={this.state.isBroadCast}
                                                sessionTypeParams={this.state.isGroupSession}
                                                isStudentView={true}
                                            />
                                        </div>
                                    </>
                                )}
                                
                                {/* Provider Info - Only show for one-to-one sessions */}
                                {!this.state.isGroupSession && !this.state.isConferenceCall && (
                                    isVisitInfoWithUserInfoScreen ||
                                        (store.get('AnonymousRole') && (
                                            <PhysicianInformation
                                                videoCallDetails={videoCallDetails}
                                                minWidth={minWidth}
                                                streams={this.state.streams}
                                                studentDetails={this.props.studentDetails}
                                                isClassRoom={this.props.isClassRoom}
                                                isBroadCast={this.state.isBroadCast}
                                                hasUrlParams={AnonymousRole}
                                                sessionTypeParams={this.state.urlParams.sessionTypeParams}
                                                educatorName={this.state.urlParams.educatorName}
                                                isConferenceCall={this.state.isConferenceCall}
                                            />
                                        ))
                                )}
                                
                                {/* Chat Messages - Only show when chat is clicked or not in group/conference session */}
                                {(this.state.messageClicked || 
                                  (!this.state.isGroupSession && !this.state.isConferenceCall)) &&
                                 (this.props.isSocketDownProblem ? (
                                    <SocketDownScreen />
                                ) : (
                                    // Only show chat if enabled for anonymous users
                                    (!store.get('AnonymousRole') ||
                                    this.state.isShowChatBtn ||
                                    this.state.isGroupSession ||
                                    this.state.isOnetoOne) && (
                                        <PatientMessage
                                            ref={(Message) => {
                                                this._message = Message;
                                            }}
                                            closeMessagePop={() => {
                                                if (store.get('AnonymousRole') && (this.state.isGroupSession || this.state.isConferenceCall)) {
                                                    this._patientMessageClick();
                                                } else {
                                                    this.closeMessagePop();
                                                }
                                            }}
                                            minWidth={this.state.minWidth}
                                            messageClicked={this.state.messageClicked}
                                            isGroupSession={this.state.isGroupSession}
                                            isConferenceCall={this.state.isConferenceCall}
                                            chatList={chatList}
                                            isChatLoading={isChatLoading}
                                            receiverImage={receiverImage}
                                            senderImage={senderImage}
                                            userType={Patient}
                                            onSendMessage={(
                                                textMessage,
                                                chatImage,
                                                havingImage,
                                                receiverId
                                            ) => {
                                                myLog(
                                                    'onSendMessage',
                                                    textMessage,
                                                    chatImage,
                                                    havingImage,
                                                    receiverId
                                                );
                                                this.invokeonSendMessage(
                                                    textMessage,
                                                    chatImage,
                                                    havingImage,
                                                    receiverId
                                                );
                                            }}
                                            isSendMessageLoading={isSendMessageLoading}
                                            videoCallDetails={videoCallDetails}
                                            isShowVideoConsultation={this.state.isShowVideoConsultation}
                                            streams={this.state.streams}
                                            studentDetails={this.props.studentDetails}
                                            isClassRoom={this.state.isClassRoom}
                                            callChatAPI={() => {
                                                this.invokeChatList(this.state.currentChatPage);
                                            }}
                                            chatLastPage={this.state.chatLastPage}
                                            currentChatPage={this.state.currentChatPage}
                                            hasUrlParams={AnonymousRole}
                                        />
                                    )
                                ))}
                            </div>
                        ) : (
                            ''
                        )}
                        <Screenshot />
                    </div>
                    <div className="fixed flex items-center justify-between">
                        {/* <div style={{ display: "flex", alignItems: "center" }}>
              {this.state.showSoap ? (
                " "
              ) : match.params.userType === Tutor ? (
                <EncounterOption
                  isPatient={false}
                  showSoap={this.state.showSoap}
                  showVideo={this.showVideo.bind(this)}
                />
              ) : (
                <EncounterOption
                  isPatient={true}
                  messageClicked={this.state.messageClicked}
                  showVideo={this.showVideo.bind(this)}
                  minWidthHandle={() =>
                    this.setState({ messageClicked: false })
                  }
                />
              )}
              {this.state.showTimer && this.props.physicianShowTimer ? (
                <TimerOption
                  props={this.props}
                  videoCallDetails={videoCallDetails}
                  studentDetails={studentDetails}
                  openVideoCallBufferAlert={() => {
                    this.setState({
                      endVideoCallFinalBufferAlert: false,
                      endVideoCallBufferAlert: true,
                    });
                  }}
                  openVideoCallFinalBufferAlert={() => {
                    this.setState({
                      endVideoCallBufferAlert: false,
                      endVideoCallFinalBufferAlert: true,
                    });
                  }}
                />
              ) : (
                ""
              )}
              <RecordingOption isRecording={isRecording} />
              {this.state.isBroadCast &&
                match.params.userType === Student &&
                !this.state.minWidth && (
                  <button
                    type="button"
                    onClick={() => {
                      this.endVideoCall();
                    }}
                    className="btn btn-danger"
                    style={{ color: "#cb3347", fontWeight: "bold" }}
                  >
                    End Call
                  </button>
                )}
            </div>
            <Footer /> */}
                    </div>
                    <Screenshot />
                    {this.endVideoCallModal()}
                    {this.endVideoCallBufferAlertModal()}
                    {this.endVideoCallBufferFinalAlertModal()}
                    {this.removeStudentAlertModal()}
                    {this.renderAnonymousEndCallPopup()}
                    {this.renderLeftSessionScreen()}

                    {/* <FetchConnectionSpeed
                        handleChangeNetworkColor={this.handleChangeNetworkColor}
                    /> */}
                </div>
                {this.state.showEarlyJoinModal && !this.state.awaitingVisitStatus && (
                    <div
                        style={{
                            position: 'fixed',
                            top: 0,
                            left: 0,
                            width: '100%',
                            height: '100%',
                            backgroundColor: 'rgba(0, 0, 0, 0.5)',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            zIndex: 9999,
                        }}
                    >
                        <div
                            className="bg-card"
                            style={{
                                // backgroundColor: 'white',
                                padding: '30px',
                                borderRadius: '8px',
                                textAlign: 'center',
                                maxWidth: '400px',
                                boxShadow: '0 0 10px rgba(0,0,0,0.3)',
                            }}
                        >
                            {/* <h2 style={{ marginBottom: "10px", fontWeight: "bold" }}>
                Access Not Yet Available
              </h2> */}
                            <p style={{ fontSize: '16px', color: 'white' }}>
                                {this.props.t('sessionNotStartedYet')}

                            </p>
                        </div>
                    </div>
                )}
                {this.renderAnonymousModal()}
            </div>
        );
    }
}

/**
 *
 * @param {*} state
 */
const mapStatetoProps = (state) => {
    const videoCallDetails = state.VideoCallState.videoCallDetails || {};
    const derivedVonageSessionDetails =
        videoCallDetails.vonage_session_details ||
        (videoCallDetails.apikey && videoCallDetails.opentokSession && videoCallDetails.opentokToken
            ? {
                  apiKey: videoCallDetails.apikey,
                  sessionId: videoCallDetails.opentokSession,
                  token: videoCallDetails.opentokToken,
                  moderatorToken: videoCallDetails.moderatorToken,
              }
            : null);

    return {
        userDetails: state.UserReducer.userDetails,
        videoCallDetails,
        vonage_session_details: derivedVonageSessionDetails,
        vonage_api_credentials: videoCallDetails.vonage_api_credentials || null, // NEW: API credentials
        isEndCallLoading: state.VideoCallState.isEndCallLoading,
        chatList: state.VideoCallState.chatList,
        isChatLoading: state.VideoCallState.isChatLoading,
        receiverImage: state.VideoCallState.receiverImage,
        senderImage: state.VideoCallState.senderImage,
        isSendMessageLoading: state.VideoCallState.isSendMessageLoading,
        chatCount: state.VideoCallState.chatCount,
        isRecording: state.VideoCallState.isRecording,
        userIds: state.VideoCallState.userIds,
        archiveId: state.VideoCallState.archiveId,
        handoutDetails: state.adminModuleReducer.physicianHandoutList,
        isMute: state.VideoCallState.isMute,
        visitEncounter: state.VideoCallState.visitEncounter,
        patientShowTimer: state.DashBoardReducer.patientShowTimer,
        physicianShowTimer: state.DashBoardReducer.physicianShowTimer,
        isOnline: state.NetworkInState.isOnline,
        isNetworkProblem: state.NetworkInState.isNetworkProblem,
        studentDetails: state.VideoCallState.studentDetails,
        isSocketDownProblem: state.NetworkInState.isSocketDownProblem,
        participantsDetails: state.VideoCallState.participantsDetails,
        isWhiteboardOpen: state.WhiteBoardReducerList.isWhiteboardOpen,
        isRecordingCall: state.VideoCallState.isRecordingCall,
        showAnonymousEndCallPopup: state.VideoCallState.showAnonymousEndCallPopup,
    };
};

/**
 *
 * @param {*} dispatch
 */
const mapDispatchtoProps = (dispatch) => {
    return {
        startChatSocketConnect: (userId, userType, visitId, props) => {
            dispatch(startChatSocketConnect(userId, userType, visitId, props));
        },
        stopChatSocketConnect: () => {
            dispatch(stopChatSocketConnect());
        },
        showNotification: (message, type) => {
            dispatch(showNotification(message, type));
        },
        endVideoCall: (visitId, isCallSuccessful, isVisitCredit, callback) => {
            dispatch(endVideoCall(visitId, isCallSuccessful, isVisitCredit, callback));
        },
        startVideoRecord: (visitId, callback) => {
            dispatch(startVideoRecord(visitId, callback));
        },
        stopVideoRecord: (visitId, callback) => {
            dispatch(stopVideoRecord(visitId, callback));
        },
        getVideoChat: (url, visitId, values, callback) => {
            dispatch(getVideoChat(url, visitId, values, callback));
        },
        onSendMessage: (input, callback) => {
            dispatch(onSendMessage(input, callback));
        },
        onPatientEndCall: (visitId, callback) => {
            dispatch(onPatientEndCall(visitId, callback));
        },
        onMuteVideo: (input, callback) => {
            dispatch(onMuteVideo(input, callback));
        },
        clearUnreadCount: () => {
            dispatch(clearUnreadCount());
        },
        updateSoap: (subjective, objective, plan, assessment) => {
            dispatch(updateSoap(subjective, objective, plan, assessment));
        },
        getPatientVisitEncounter: (visitId, callback) => {
            dispatch(getPatientVisitEncounter(visitId, callback));
        },
        getHandout: (callback) => {
            dispatch(getHandout(callback));
        },
        saveSnapShot: (visitId, photo, callback) => {
            dispatch(saveSnapShot(visitId, photo, callback));
        },
        getNewVideoFlowConfig: (visitId, callback) => {
            dispatch(getNewVideoFlowConfig(visitId, callback));
        },
        getVonageSessionDetails: (visitId, callback) => {
            dispatch(getVonageSessionDetails(visitId, callback));
        },
        getKidInfo: (visitId, callBack) => {
            dispatch(getKidInfo(visitId, callBack));
        },
        startBroadCast: (visitId, callBack) => {
            dispatch(startBroadCast(visitId, callBack));
        },
        endStudentBroadCastSession: (callBack) => {
            dispatch(endStudentBroadCastSession(callBack));
        },
        classRoomStudentRemove: (values, callBack) => {
            dispatch(classRoomStudentRemove(values, callBack));
        },
        educatorMuteMessage: (values, isMute, callBack) => {
            dispatch(educatorMuteMessage(values, isMute, callBack));
        },
        endVideoChatClear: () => {
            dispatch(endVideoChatClear());
        },
        joinInPersonSession: (visitId, callback) => {
            dispatch(joinInPersonSession(visitId, callback));
        },
        anonymousUserDetails: (values, callBack) => {
            dispatch(anonymousUserDetails(values, callBack));
        },
        getVisitStatus: (visitId, callBack) => {
            dispatch(getVisitStatus(visitId, callBack));
        },
    };
};

const ConnectedActiveVisit = withLanguage(
    connect(mapStatetoProps, mapDispatchtoProps)(ActiveVisit)
);

export default (props) => (
    <LanguageProvider>
        <ConnectedActiveVisit {...props} />
    </LanguageProvider>
);
